/* Polski — Polish */
const pl = {
  nav: {
    home: 'Strona Główna',
    imageConverter: 'Konwerter Obrazów',
    imageCompressor: 'Kompresor Obrazów',
    otherTools: 'Inne Narzędzia',
    resizeImage: 'Zmień Rozmiar',
    cropImage: 'Przytnij Obraz',
    photoEditor: 'Edytor Zdjęć',
    removeBackground: 'Usuń Tło',
    watermarkImage: 'Znak Wodny',
    qrCodeGenerator: 'Generator Kodów QR',
    qrCodeScanner: 'Skaner Kodów QR',
    aboutUs: 'O Nas',
    faceBlur: 'Rozmycie Twarzy',
  },

  hero: {
    heading: 'Wszystkie Narzędzia do Obrazów, Których Potrzebujesz',
    subheading: 'Darmowe narzędzia online do konwertowania, kompresji, zmiany rozmiaru, przycinania i edycji obrazów. Całe przetwarzanie odbywa się w przeglądarce — szybko i bezpiecznie.',
  },

  tools: {
    compressImage: { title: 'Kompresuj Obraz', desc: 'Kompresuj JPG, PNG, SVG i GIF zachowując jakość.' },
    resizeImage: { title: 'Zmień Rozmiar Obrazu', desc: 'Zmień rozmiar procentowo lub w pikselach.' },
    cropImage: { title: 'Przytnij Obraz', desc: 'Łatwo przytnij JPG, PNG i GIF.' },
    convertToJpg: { title: 'Konwertuj do JPG', desc: 'Zbiorowo konwertuj PNG, GIF, TIF, SVG, WEBP i inne do JPG.' },
    convertFromJpg: { title: 'Konwertuj z JPG', desc: 'Konwertuj obrazy JPG do PNG i GIF.' },
    qrCodeGenerator: { title: 'Generator Kodów QR', desc: 'Twórz niestandardowe kody QR dla URL, tekstu, WiFi, kontaktów i nie tylko.' },
    qrCodeScanner: { title: 'Skaner Kodów QR', desc: 'Natychmiast skanuj kody QR kamerą lub przesyłając obraz.' },
    blurFace: { title: 'Rozmycie Twarzy', desc: 'Automatycznie wykrywaj i rozmywaj twarze na zdjęciach dla ochrony prywatności.' },
    removeBackground: { title: 'Usuń Tło', desc: 'Szybko usuwaj tło obrazu z wysoką precyzją.' },
    watermarkImage: { title: 'Znak Wodny', desc: 'Dodawaj znaki wodne do obrazów w kilka sekund.' },
  },

  whyChoose: {
    label: 'Dlaczego My',
    heading: 'Inteligentniejszy Sposób Edycji Obrazów',
    subheading: 'Zaufany przez tysiące twórców, projektantów i programistów na całym świecie.',
    reasons: {
      fast: { title: 'Błyskawicznie Szybki', desc: 'Całe przetwarzanie odbywa się bezpośrednio w przeglądarce. Bez przesyłania na zewnętrzne serwery.' },
      private: { title: '100% Bezpieczny i Prywatny', desc: 'Twoje pliki nigdy nie opuszczają urządzenia. Nie przechowujemy ani nie udostępniamy Twoich obrazów.' },
      noLimits: { title: 'Bez Limitów, Bez Rejestracji', desc: 'Używaj wszystkich narzędzi ile chcesz — całkowicie za darmo.' },
      quality: { title: 'Profesjonalna Jakość', desc: 'Nasze algorytmy dostarczają wyniki na poziomie profesjonalnym.' },
      batch: { title: 'Przetwarzanie Zbiorcze', desc: 'Przetwarzaj wiele plików naraz.' },
      everywhere: { title: 'Działa Wszędzie', desc: 'Działa doskonale na komputerze, tablecie i telefonie.' },
    },
    stats: {
      imagesProcessed: 'Przetworzonych Obrazów',
      countriesServed: 'Obsługiwanych Krajów',
      uptime: 'Dostępność',
      freeTools: 'Bezpłatnych Narzędzi',
    },
  },

  footer: {
    tagline: 'Darmowe narzędzia do obrazów online — konwertuj, kompresuj, zmieniaj rozmiar, przycinaj i edytuj obrazy w kilka sekund.',
    imageTools: 'Narzędzia Obrazów',
    moreTools: 'Więcej Narzędzi',
    company: 'Firma',
    contact: 'Kontakt',
    allRightsReserved: 'Wszelkie prawa zastrzeżone.',
    privacyPolicy: 'Polityka Prywatności',
    termsOfService: 'Warunki Użytkowania',
  },

  faq: {
    badge: 'FAQ',
    heading: 'Często Zadawane Pytania',
    subheading: 'Szybkie odpowiedzi na typowe pytania dotyczące tych narzędzi.',
    stillHaveQuestions: 'Masz jeszcze pytania? Chętnie pomożemy!',
    reachOut: 'Skontaktuj się z Nami',
    questionHeader: 'Pytanie',
  },

  contactForm: {
    badge: 'Napisz do Nas',
    title: 'Napisz do Nas',
    subtitle: 'Chętnie wysłuchamy. Wyślij nam wiadomość!',
    nameLabel: 'Imię',
    namePlaceholder: 'Twoje imię i nazwisko',
    emailLabel: 'E-mail',
    emailPlaceholder: 'ty@email.pl',
    subjectLabel: 'Temat',
    subjectPlaceholder: 'Czego dotyczy?',
    messageLabel: 'Wiadomość',
    messagePlaceholder: 'Napisz swoją wiadomość tutaj…',
    errName: 'Imię jest wymagane',
    errEmail: 'E-mail jest wymagany',
    errEmailInvalid: 'Wprowadź prawidłowy e-mail',
    errSubject: 'Temat jest wymagany',
    errMessage: 'Wiadomość jest wymagana',
    sending: 'Wysyłanie…',
    send: 'Wyślij Wiadomość',
    successTitle: 'Wiadomość Wysłana!',
    successMsg: 'Dziękujemy za kontakt. Odpiszemy wkrótce.',
    sendAnother: 'Wyślij Kolejną',
    sendError: 'Coś poszło nie tak. Spróbuj ponownie.',
  },

  about: {
    label: 'O Nas',
    heading: 'Stworzone dla Twórców, przez Twórców',
    subheading: 'Wierzymy, że potężne narzędzia do obrazów powinny być darmowe, szybkie i dostępne dla każdego.',
    missionTitle: 'Nasza Misja',
    missionText: 'photremium.com powstało z prostym celem: zapewnić najbardziej intuicyjne, najszybsze i najbardziej prywatne doświadczenie edycji obrazów w sieci.',
    privacyTitle: 'Prywatność na Pierwszym Miejscu',
    privacyText: 'Nie przesyłamy, nie przechowujemy ani nie przetwarzamy zdalnie Twoich obrazów. Wszystko pozostaje na Twoim urządzeniu.',
    techTitle: 'Nowoczesna Technologia',
    techText: 'Zbudowano przy użyciu najnowszych technologii webowych, w tym WebAssembly, Canvas API i nowoczesnego React.',
    communityTitle: 'Zorientowane na Społeczność',
    communityText: 'Każda funkcja jest inspirowana opiniami prawdziwych użytkowników.',
    globalTitle: 'Globalny Zasięg',
    globalText: 'Używany przez twórców z ponad 120 krajów.',
  },

  seo: {
    homeTitle: 'photremium.com — Darmowy Konwerter, Kompresor i Edytor Obrazów Online',
    homeDesc: 'Konwertuj, kompresuj, zmieniaj rozmiar, przycinaj i edytuj obrazy za darmo online.',
    homeKeywords: 'konwerter obrazów, kompresor obrazów, zmień rozmiar obrazu, przytnij obraz, edytor zdjęć',
    aboutTitle: 'O photremium.com — Nasza Misja',
    aboutDesc: 'Dowiedz się o photremium.com, darmowym zestawie narzędzi do obrazów online, któremu ufa miliony.',
    aboutKeywords: 'o photremium.com, narzędzia obrazów, darmowy edytor obrazów',
  },

      privacyPolicyPage: {
    seo: {
      title: 'Polityka prywatności — Photremium | Brak przesyłania na serwer, brak przechowywania danych',
      description: 'Polityka prywatności Photremium wyjaśnia, w jaki sposób chronimy Twoją prywatność. Całe przetwarzanie obrazu odbywa się w 100% w Twojej przeglądarce — bez przesyłania plików na serwer, bez gromadzenia danych osobowych i bez śledzenia.',
      ogTitle: 'Polityka prywatności — Photremium | Żadnych przesyłań, zero miejsca na dane',
      ogDescription: 'Twoje pliki pozostają na Twoim urządzeniu. Photremium przetwarza wszystkie obrazy lokalnie w Twojej przeglądarce, bez kontaktu z serwerem, bez przechowywania danych i bez śledzenia.',
      twitterTitle: 'Polityka prywatności — Photremium',
      twitterDescription: 'Narzędzia graficzne w 100% oparte na przeglądarce. Żadnych przesyłań, żadnego przechowywania, żadnego śledzenia. Przeczytaj naszą pełną politykę prywatności.',
      schemaName: 'Polityka prywatności - Fotremium',
      schemaDescription: 'Polityka prywatności Photremium - brak przesyłania plików na serwer, brak przechowywania danych, 100% przetwarzanie obrazu w przeglądarce.'
    },
    hero: {
      badge: 'Polityka prywatności',
      titlePrefix: 'Twoja prywatność jest nasza',
      titleHighlight: 'Najwyższy priorytet',
      subPrefix: 'photremium.com opiera się na prostej zasadzie —',
      subStrong: 'Twoje pliki nigdy nie opuszczają Twojego urządzenia',
      subSuffix: 'Każde narzędzie graficzne na tej stronie działa całkowicie w przeglądarce. Brak przesyłania. Brak chmury. Bez kompromisów.',
      effectiveLabel: 'Skuteczny',
      lastUpdatedLabel: 'Ostatnia aktualizacja',
      worldwideLabel: 'Obowiązuje na całym świecie'
    },
    trustCards: [
      {
        title: 'Brak przesyłania plików na serwer',
        desc: 'Twoje pliki nigdy nie opuszczają Twojego urządzenia. Całe przetwarzanie odbywa się w 100% w przeglądarce.'
      },
      {
        title: 'Zerowa pamięć danych',
        desc: 'Nie przechowujemy niczego na temat Ciebie, Twoich zdjęć ani Twojej aktywności.'
      },
      {
        title: 'Brak śledzenia',
        desc: 'Żadnego śledzenia zachowań, pobierania odcisków palców i profilowania.'
      },
      {
        title: 'Przyjazny dla RODO',
        desc: 'Zaprojektowany od podstaw z poszanowaniem globalnych przepisów dotyczących prywatności.'
      }
    ],
    contentsTitle: 'Zawartość',
    toc: {
      overview: 'Przegląd',
      'no-upload': 'Brak przetwarzania serwera',
      'data-collect': 'Dane, które zbieramy',
      cookies: 'Pliki cookie i przechowywanie',
      'third-party': 'Usługi stron trzecich',
      analytics: 'Analityka',
      children: 'Prywatność dzieci',
      rights: 'Twoje prawa',
      security: 'Bezpieczeństwo',
      changes: 'Zmiany zasad',
      contact: 'Skontaktuj się z nami'
    },
    sections: {
      overview: {
        title: '1. Przegląd',
        subtitle: 'Co obejmuje ta polityka',
        p1Prefix: 'Niniejsza Polityka prywatności opisuje, w jaki sposób',
        p1Middle: '(„my”, „nas” lub „nasz”) oznacza - lub dokładniej,',
        p1Italic: 'nie radzi sobie',
        p1Suffix: 'Twoje dane osobowe podczas korzystania z naszych bezpłatnych narzędzi do tworzenia obrazów online pod adresem',
        p2: 'W przeciwieństwie do tradycyjnych aplikacji internetowych, które wysyłają pliki do zdalnych serwerów w celu przetworzenia, photremium.com korzysta z nowoczesnych interfejsów API przeglądarki (Canvas API, WebAssembly, WebWorkers), aby wykonywać każdą operację lokalnie na Twoim urządzeniu. Rezultat: brak transmisji danych, brak przechowywania, brak ryzyka.',
        calloutLabel: 'Proste podsumowanie w języku angielskim:',
        calloutText: 'Nie możemy zobaczyć Twoich zdjęć, nie chcemy, a nasza technologia została specjalnie zaprojektowana, aby nigdy nie było to możliwe.'
      },
      noUpload: {
        title: '2. Żadnego przetwarzania przez serwer — nigdy',
        subtitle: 'Jak faktycznie działają nasze narzędzia',
        introPrefix: 'Każde narzędzie na photremium.com — konwerter obrazów, kompresor, zmiana rozmiaru, usuwanie tła, rozmazywanie twarzy, znak wodny, przycinanie i narzędzia do kodów QR — przetwarza Twoje pliki',
        introStrong: '100% w Twojej przeglądarce internetowej',
        introSuffix: 'przy użyciu JavaScript i WebAssembly po stronie klienta.',
        points: [
          {
            label: 'Nigdy nie następuje przesyłanie plików.',
            text: 'Po wybraniu pliku jest on odczytywany przez interfejs File API przeglądarki i przetwarzany w pamięci — nigdy nie jest przesyłany przez sieć.'
          },
          {
            label: 'Żaden serwer nie odbiera Twojego obrazu.',
            text: 'Nasza sieć CDN udostępnia tylko zasoby HTML, CSS i JavaScript potrzebne do uruchomienia aplikacji, a nie Twoje pliki.'
          },
          {
            label: 'Brak tymczasowego przechowywania.',
            text: 'Przetworzone wyniki istnieją wyłącznie w pamięci Twojej przeglądarki i są uwalniane w momencie zamknięcia strony lub opuszczenia jej.'
          },
          {
            label: 'Działa w trybie offline.',
            text: 'Większość narzędzi nadal działa bez połączenia z Internetem po początkowym załadowaniu strony – to kolejny dowód, że nie jest zaangażowany żaden serwer.'
          }
        ],
        callout: 'Możesz to sprawdzić samodzielnie: otwórz kartę Sieć w przeglądarce w Narzędziach dla programistów, wybierz obraz i potwierdź, że żadne dane pliku nie są przesyłane na żaden serwer zewnętrzny.'
      },
      dataCollect: {
        title: '3. Dane, które zbieramy (i których nie zbieramy)',
        subtitle: 'Pełna przejrzystość praktyk dotyczących danych',
        headers: {
          type: 'Typ danych',
          collected: 'Zebrane?',
          whereWhy: 'Gdzie/Dlaczego'
        },
        rows: [
          {
            type: 'Twoje obrazy/pliki',
            badge: 'Nigdy',
            variant: 'zielony',
            showX: true,
            whereWhy: 'Przetwarzane w całości w Twojej przeglądarce — nigdy nie przesyłane'
          },
          {
            type: 'Imię i nazwisko/adres e-mail',
            badge: 'Nigdy',
            variant: 'zielony',
            showX: true,
            whereWhy: 'Aby korzystać z dowolnego narzędzia, nie jest wymagane żadne konto ani rejestracja'
          },
          {
            type: 'Adres IP',
            badge: 'Minimalny',
            variant: 'szary',
            showX: false,
            whereWhy: 'Standardowe logi serwera WWW przechowywane <= 30 dni, niezwiązane z tożsamością'
          },
          {
            type: 'Typ przeglądarki/systemu operacyjnego',
            badge: 'Minimalny',
            variant: 'szary',
            showX: false,
            whereWhy: 'Wysyłane automatycznie przez Twoją przeglądarkę; używany wyłącznie w celu zapewnienia kompatybilności'
          },
          {
            type: 'Odwiedzone strony / kliknięcia',
            badge: 'Zagregowane',
            variant: 'niebieski',
            showX: false,
            whereWhy: 'Tylko anonimowe analizy (bez identyfikacji osobistej)'
          },
          {
            type: 'Preferencje językowe',
            badge: 'Tylko lokalnie',
            variant: 'niebieski',
            showX: false,
            whereWhy: 'Zapisane w localStorage na Twoim urządzeniu — nigdy do nas nie wysyłane'
          },
          {
            type: 'Dane płatnicze/finansowe',
            badge: 'Nigdy',
            variant: 'zielony',
            showX: true,
            whereWhy: 'photremium.com jest całkowicie darmowe i nie wymaga żadnych opłat'
          }
        ]
      },
      cookies: {
        title: '4. Pliki cookie i pamięć lokalna',
        subtitle: 'Co jest zapisywane na Twoim urządzeniu',
        intro: 'photremium.com nie używa reklamowych plików cookie, plików cookie śledzących między witrynami ani plików cookie stron trzecich. Jedyne miejsce w przeglądarce, którego używamy, służy do przechowywania niezbędnych funkcji witryny.',
        points: [
          {
            label: 'Preferencje językowe',
            text: 'Przechowywane w localStorage, dzięki czemu witryna zapamiętuje preferowany język pomiędzy wizytami. Nigdy nie wysyłane na nasze serwery.'
          },
          {
            label: 'Preferencje motywu/interfejsu',
            text: 'Jeśli ustawisz preferencje wyświetlania, zostaną one zapisane lokalnie tylko na Twoim urządzeniu.'
          },
          {
            label: 'Brak plików cookie sesji.',
            text: 'photremium.com nie ma systemu logowania, więc nie są zapisywane żadne pliki cookie identyfikujące sesję.'
          }
        ],
        callout: 'Możesz w każdej chwili wyczyścić całą pamięć lokalną photremium.com za pomocą ustawień przeglądarki (Ustawienia -> Prywatność -> Wyczyść dane przeglądania -> Dane w pamięci podręcznej i pliki cookie). Nie ma to wpływu na możliwość korzystania z narzędzi.'
      },
      thirdParty: {
        title: '5. Usługi stron trzecich',
        subtitle: 'Usługi zewnętrzne, z których korzystamy i dlaczego',
        intro: 'photremium.com korzysta z minimalnego zestawu zaufanych usług stron trzecich, wyłącznie w zakresie infrastruktury i wydajności. Żadna z tych usług nie otrzymuje Twoich zdjęć ani żadnych danych osobowych.',
        headers: {
          service: 'Praca',
          purpose: 'Zamiar',
          dataShared: 'Dane udostępnione',
          privacyPolicy: 'Polityka prywatności'
        },
        rows: [
          {
            service: 'Strony Cloudflare',
            purpose: 'Hosting i dostarczanie zasobów witryny przez CDN',
            dataShared: 'Adres IP, nagłówki HTTP (standard)',
            privacyLink: 'https://www.cloudflare.com/privacypolicy/',
            privacyText: 'cloudflare.com/privacypolicy'
          },
          {
            service: 'Czcionka niesamowita',
            purpose: 'Czcionki ikon załadowane z CDN',
            dataShared: 'Adres IP (tylko żądanie CSS)',
            privacyLink: 'https://fontawesome.com/privacy',
            privacyText: 'fontawesome.com/privacy'
          },
          {
            service: 'Czcionki Google',
            purpose: 'Ładowanie kroju pisma (jeśli dotyczy)',
            dataShared: 'Adres IP (tylko żądanie czcionki)',
            privacyLink: 'https://policies.google.com/privacy',
            privacyText: 'policies.google.com'
          }
        ],
        outro: 'Nie udostępniamy Twoich danych reklamodawcom, brokerom danych ani żadnym innym osobom trzecim poza dostawcami infrastruktury wymienionymi powyżej.'
      },
      analytics: {
        title: '6. Analityka',
        subtitle: 'Zbiorcze, szanujące prywatność dane dotyczące użytkowania',
        introPrefix: 'Możemy zbierać dane, aby dowiedzieć się, które narzędzia są popularne i jak ulepszyć witrynę',
        introStrong: 'zagregowane i zanonimizowane',
        introSuffix: 'statystyki użytkowania, takie jak:',
        points: [
          'Liczba odsłon strony na narzędzie (bez identyfikacji użytkownika)',
          'Źródło skierowania (np. wyszukiwarka Google, link bezpośredni) – brak danych osobowych',
          'Dane geograficzne na poziomie kraju (nie miasto ani dokładna lokalizacja)',
          'Typ przeglądarki/urządzenia do analizy kompatybilności'
        ],
        calloutLabel: 'Żadne dane nie są powiązane z Tobą osobiście.',
        calloutText: 'Nie korzystamy z Google Analytics ani Meta Pixel. Wszelkie wykorzystywane przez nas narzędzia analityczne to narzędzia zapewniające prywatność (np. wiarygodne lub podobne).'
      },
      children: {
        title: '7. Prywatność dzieci',
        subtitle: 'Zgodność z COPPA i bezpieczeństwem dzieci',
        p1: 'photremium.com nie zbiera świadomie żadnych danych osobowych od dzieci poniżej 13 roku życia (lub 16 lat w Unii Europejskiej zgodnie z RODO). Ponieważ nie zbieramy żadnych danych osobowych od żadnego użytkownika, nie mamy nic specjalnego do zrobienia dla młodszych użytkowników – strona jest równie bezpieczna dla wszystkich.',
        p2Prefix: 'Jeśli uważasz, że dziecko w jakiś sposób przekazało dane osobowe za pośrednictwem naszego formularza kontaktowego, skontaktuj się z nami natychmiast pod adresem',
        p2Suffix: 'i niezwłocznie go usuniemy.'
      },
      rights: {
        title: '8. Twoje prawa',
        subtitle: 'RODO, CCPA i globalne prawa do prywatności',
        intro: 'Ponieważ photremium.com nie gromadzi żadnych danych osobowych, większość praw osób, których dane dotyczą, ma banalne zastosowanie – nie ma żadnych danych o Tobie, do których można uzyskać dostęp, poprawić je lub usunąć. Niemniej jednak w pełni uznajemy i szanujemy następujące prawa:',
        points: [
          {
            label: 'Prawo dostępu',
            text: 'Możesz poprosić o kopię wszelkich danych, które o Tobie posiadamy. (Nie ma nic poza anonimowymi dziennikami.)'
          },
          {
            label: 'Prawo do sprostowania',
            text: 'Możesz zażądać poprawienia nieprawidłowych danych osobowych.'
          },
          {
            label: 'Prawo do usunięcia danych („Prawo do bycia zapomnianym”)',
            text: 'Możesz zażądać usunięcia wszelkich danych osobowych, które posiadamy (art. 17 RODO, CCPA).'
          },
          {
            label: 'Prawo do sprzeciwu/rezygnacji',
            text: 'Możesz zrezygnować z przyszłego gromadzenia danych analitycznych, korzystając z narzędzia do rezygnacji lub blokowania reklam na poziomie przeglądarki.'
          },
          {
            label: 'Prawo do przenoszenia danych',
            text: 'Cała Twoja praca jest pobierana bezpośrednio na Twoje urządzenie — nie jest wymagana żadna prośba o eksport.'
          }
        ],
        callout: 'Prawa te mają zastosowanie do wszystkich użytkowników na całym świecie, niezależnie od jurysdykcji – jako podstawę stosujemy najwyższe standardy (RODO).'
      },
      security: {
        title: '9. Bezpieczeństwo',
        subtitle: 'Jak chronimy Twoje doświadczenia',
        intro: 'Najbezpieczniejsze dane to dane, które nigdy nie są gromadzone. Architektura po stronie klienta photremium.com oznacza, że ​​włamanie na serwer nie może ujawnić Twoich plików, ponieważ nigdy nie znajdują się one na naszych serwerach. Dodatkowe środki bezpieczeństwa obejmują:',
        points: [
          {
            label: 'Egzekwowanie protokołu HTTPS',
            text: 'Cały ruch między Twoją przeglądarką a naszym CDN jest szyfrowany za pomocą protokołu TLS 1.2+ z HSTS.'
          },
          {
            label: 'Polityka bezpieczeństwa treści (CSP)',
            text: 'Ścisłe nagłówki zapobiegają wykonywaniu skryptów między witrynami i wstrzykiwaniu skryptów wbudowanych.'
          },
          {
            label: 'Regularne audyty zależności',
            text: 'Regularnie audytujemy i aktualizujemy pakiety npm, aby załatać znane luki.'
          }
        ],
        disclosurePrefix: 'Odpowiedzialne ujawnianie',
        disclosureTextPrefix: 'Znalazłeś problem bezpieczeństwa? Napisz do nas na adres',
        disclosureTextSuffix: 'a my odpowiemy w ciągu 48 godzin.'
      },
      changes: {
        title: '10. Zmiany w niniejszej Polityce',
        subtitle: 'Jak postępujemy z aktualizacjami zasad',
        intro: 'Od czasu do czasu możemy aktualizować niniejszą Politykę prywatności, aby odzwierciedlić zmiany w naszych praktykach, narzędziach lub wymaganiach prawnych. Kiedy to robimy:',
        points: [
          {
            label: '„Ostatnia aktualizacja”',
            text: 'data na górze tej strony zostanie zmieniona.'
          },
          {
            label: 'Zmiany materialne',
            text: 'zostaną ogłoszone w widocznym ogłoszeniu na stronie głównej przez co najmniej 30 dni.'
          },
          {
            label: 'Poprzednie wersje',
            text: 'niniejszej polityki będą archiwizowane i dostępne na żądanie.'
          }
        ],
        outro: 'Dalsze korzystanie z photremium.com po opublikowaniu zmian oznacza akceptację zaktualizowanej polityki. Zachęcamy do okresowego przeglądania tej strony.'
      },
      contact: {
        title: '11. Prośby o kontakt i dane',
        subtitle: 'Skontaktuj się w sprawie prywatności',
        p1Prefix: 'W przypadku jakichkolwiek pytań, wątpliwości lub formalnych próśb o dane związanych z niniejszą Polityką prywatności, prosimy o kontakt. Naszym celem jest odpowiadanie na wszystkie zapytania dotyczące prywatności w ramach naszej witryny',
        p1Strong: '5 dni roboczych'
      }
    },
    footer: {
      privacyQuestionsTitle: 'Pytania dotyczące prywatności?',
      privacyQuestionsDesc: 'Wyślij nam swoje pytania dotyczące prywatności, prośby o dane lub wątpliwości, a my niezwłocznie odpowiemy.',
      versionHistoryTitle: 'Historia wersji',
      v2Label: 'v2.0 — Major rewrite',
      v11Label: 'v1.1 — Added CCPA rights',
      v10Label: 'v1.0 — Initial policy'
    }
  },
common: {
    new: 'Nowość!',
    download: 'Pobierz',
    downloadAll: 'Pobierz Wszystkie',
    downloadAs: 'Pobierz jako:',
    zip: 'ZIP',
    separate: 'Osobno',
    upload: 'Prześlij',
    dragDrop: 'Przeciągnij i upuść obrazy tutaj lub kliknij, aby przeglądać',
    remove: 'Usuń',
    reset: 'Resetuj',
    apply: 'Zastosuj',
    cancel: 'Anuluj',
    clear: 'Wyczyść',
    close: 'Zamknij',
    save: 'Zapisz',
    processing: 'Przetwarzanie...',
    noFiles: 'Nie wybrano pliku',
    selectFiles: 'Wybierz Pliki',
    or: 'lub',
    browseFiles: 'Przeglądaj Pliki',
    dropHere: 'Upuść obrazy tutaj',
    chooseFiles: 'Wybierz Pliki',
    pasteHint: 'Możesz też wkleić obraz',
    quality: 'Jakość',
    width: 'Szerokość',
    height: 'Wysokość',
    format: 'Format',
    compression: 'Kompresja',
    preview: 'Podgląd',
    original: 'Oryginał',
    result: 'Wynik',
    before: 'Przed',
    after: 'Po',
    startOver: 'Zacznij Od Nowa',
    startOverConfirm: 'Usunąć wszystkie obrazy i zacząć od nowa?',
    addMoreImages: 'Dodaj Więcej Obrazów',
    addImage: 'Dodaj Obraz',
    images: 'obrazów',
    totalSize: 'Łączny Rozmiar',
    size: 'Rozmiar',
    type: 'Typ',
    unsavedEdits: 'Masz niezapisane zmiany. Opuścić tę stronę?',
    compareSlider: 'Suwak Porównania',
    toggleToolsPanel: 'Przełącz Panel Narzędzi',
    closePanel: 'Zamknij Panel',
    zoomIn: 'Przybliż',
    zoomOut: 'Oddal',
    fit: 'Dopasuj',
    none: 'Brak',
  },

  compressor: {
    seo: {
      uploadTitle: 'Kompresor Obrazów — Kompresuj JPG, PNG, SVG, GIF za Darmo | photremium.com',
      uploadDesc: 'Kompresuj obrazy JPG, PNG, SVG i GIF za darmo online. Zmniejsz rozmiar pliku do 80% zachowując jakość.',
      uploadKeywords: 'kompresor obrazów, kompresja jpg, kompresja png, zmniejsz rozmiar obrazu',
      workspaceTitle: 'Kompresowanie Obrazów — Kompresor Obrazów photremium.com',
      workspaceDesc: 'Dostosuj poziom kompresji i pobierz zoptymalizowane obrazy.',
      workspaceKeywords: 'kompresja obrazów, optymalizacja obrazów',
    },
    title: 'Kompresor Obrazów',
    desc: 'Kompresuj obrazy JPG, PNG i GIF do 80%. Szybko i bezpiecznie.',
    toCompress: 'do skompresowania',
    compressionForAll: 'Kompresja dla wszystkich obrazów',
    summary: 'Podsumowanie',
    originalSize: 'Oryginalny Rozmiar',
    compressed: 'Skompresowano',
    saved: 'Zaoszczędzono',
    compressionLabel: 'Kompresja:',
    compressing: 'Kompresowanie…',
    compressDownload: 'Kompresuj i Pobierz',
    lowQualityWarning: 'Wysoka kompresja może wyraźnie obniżyć ostrość obrazu.',
    blog: {
      tocTitle: 'Spis treści',
      title: 'Blog kompresora obrazów',
      formatsIntro: 'Nasze narzędzie obsługuje wszystkie formaty obrazów, więc możesz bezproblemowo kompresować dowolny obraz. Pełna lista formatów znajduje się poniżej:',
      sections: [
        {
          id: 'imgcomp-card-1',
          title: '1. Czym jest kompresor obrazów?',
          paragraphs: [
            'Kompresor obrazów to oprogramowanie lub usługa online, która zmniejsza rozmiar pliku obrazu przy zachowaniu jakości wizualnej. Zbyt duża kompresja może jednak zauważalnie pogorszyć jakość.',
          ],
          listTitle: 'TYPY:',
          bullets: [
            'Kompresja stratna: rozmiar obrazu jest zmniejszany przez usunięcie części danych. Jakość może spaść, ale często zmiana jest słabo widoczna gołym okiem.',
            'Kompresja bezstratna: zmniejsza rozmiar pliku bez pogorszenia jakości wizualnej obrazu.',
          ],
        },
        {
          id: 'imgcomp-card-2',
          title: '2. Dlaczego warto wybrać nasze narzędzie?',
          bullets: [
            'Nasz kompresor obrazów oparty na AI działa płynnie na wszystkich urządzeniach i zapewnia najlepsze możliwe wyniki.',
            'Możesz kompresować wiele obrazów jednocześnie (nawet 100+) jednym kliknięciem.',
            'Nie musisz przesyłać obrazów na serwer. Wszystko odbywa się lokalnie w przeglądarce.',
            'Nasz kompresor obrazów jest całkowicie darmowy na zawsze. Możesz też udostępnić go znajomym.',
            'Możesz wybrać poziom kompresji zgodnie ze swoimi potrzebami.',
          ],
        },
        {
          id: 'imgcomp-card-3',
          title: '3. Instrukcja krok po kroku',
          steps: [
            {
              heading: '1. Wybierz obraz(y), które chcesz skompresować.',
              bullets: [
                'Przeciągnij i upuść obraz(y) do pola przesyłania.',
                'Możesz też skopiować obraz(y) i wkleić je do pola za pomocą (Ctrl + V).',
                'Obsługiwany jest także eksplorator plików po kliknięciu przycisku wyboru.',
              ],
            },
            {
              heading: '2. Następnie wybierz procent kompresji.',
              bullets: [
                'Poziomy suwak pozwala wygodnie ustawić poziom kompresji. Korzystaj z poniższych zakresów, aby uzyskać dokładne wyniki.',
              ],
              table: {
                headers: ['Procent kompresji', 'Wynik'],
                rows: [
                  ['1%  do  40%', 'Najlepsza jakość'],
                  ['41%  do  60%', 'Normalna jakość (Zalecane)'],
                  ['61%  do  100%', 'Niska jakość'],
                ],
              },
            },
            {
              heading: '3. Sprawdź, ile miejsca zaoszczędziłeś.',
              paragraphs: [
                'Wszystkie metryki rozmiaru są wyświetlane w czasie rzeczywistym. Możesz wyraźnie zobaczyć, ile miejsca udało się zaoszczędzić, i dostosować poziom kompresji do swoich wymagań.',
              ],
            },
            {
              heading: '4. Wybierz opcję pobierania przełącznikiem.',
              bullets: [
                'ZIP: jeśli kompresujesz wiele obrazów, pojawi się ta opcja. Spakuje wszystkie skompresowane obrazy do jednego pliku ZIP (zalecane przy większej liczbie obrazów).',
                'Oddzielnie: pobiera wszystkie obrazy osobno, a nie jako jeden ZIP (zalecane przy małej liczbie obrazów, mniej niż 10).',
              ],
            },
            {
              heading: '5. Skompresuj i pobierz obrazy.',
              paragraphs: [
                'Ten przycisk automatycznie pobierze wszystkie skompresowane obrazy zgodnie z wybraną opcją pobierania.',
              ],
            },
          ],
        },
        {
          id: 'imgcomp-card-4',
          title: '4. Korzyści z kompresora obrazów.',
          bullets: [
            'Mniejsze koszty przechowywania: kompresja obrazu znacząco zmniejsza zajmowane miejsce.',
            'Szybsze ładowanie: skompresowane obrazy ładują się szybciej i poprawiają doświadczenie użytkownika.',
            'Rozwiązanie limitu Gmail: Gmail ogranicza załączniki do 25MB, więc kompresja pozwala wysłać więcej plików.',
            'Szybsze udostępnianie i przesyłanie: duże pliki wysyłają się dłużej; kompresja oszczędza czas i transfer.',
            'Optymalizacja prezentacji: niekompresowane obrazy zwiększają wagę pliku, a kompresja znacząco ją obniża.',
          ],
        },
        {
          id: 'imgcomp-card-5',
          title: '5. Obsługiwane formaty.',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  converter: {
    seo: {
      uploadTitle: 'Konwerter Obrazów — Konwertuj PNG, JPG, WEBP, GIF, SVG za Darmo | photremium.com',
      uploadDesc: 'Konwertuj obrazy między JPG, PNG, WEBP, GIF, SVG, TIFF i BMP. Darmowy konwerter formatów obrazów online.',
      uploadKeywords: 'konwerter obrazów, png do jpg, jpg do png, konwerter webp',
      workspaceKeywords: 'konwersja obrazów, konwerter formatów obrazów',

      routeKeywords: {

        'png-to-jpg': 'png do konwersji jpg, png to jpg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'jpg-to-png': 'jpg do konwersji png, jpg to png, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'png-to-webp': 'png do konwersji webp, png to webp, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'jpg-to-webp': 'jpg do konwersji webp, jpg to webp, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'webp-to-jpg': 'webp do konwersji jpg, webp to jpg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'webp-to-png': 'webp do konwersji png, webp to png, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'gif-to-jpg': 'gif do konwersji jpg, gif to jpg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'gif-to-png': 'gif do konwersji png, gif to png, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'bmp-to-jpg': 'bmp do konwersji jpg, bmp to jpg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'bmp-to-png': 'bmp do konwersji png, bmp to png, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'svg-to-png': 'svg do konwersji png, svg to png, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'svg-to-jpg': 'svg do konwersji jpg, svg to jpg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'tiff-to-jpg': 'tiff do konwersji jpg, tiff to jpg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'tiff-to-png': 'tiff do konwersji png, tiff to png, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'jpg-to-gif': 'jpg do konwersji gif, jpg to gif, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'png-to-gif': 'png do konwersji gif, png to gif, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'jpg-to-bmp': 'jpg do konwersji bmp, jpg to bmp, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'png-to-bmp': 'png do konwersji bmp, png to bmp, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'webp-to-gif': 'webp do konwersji gif, webp to gif, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'jpg-to-ico': 'jpg do konwersji ico, jpg to ico, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'png-to-ico': 'png do konwersji ico, png to ico, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'jpg-to-svg': 'jpg do konwersji svg, jpg to svg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'png-to-svg': 'png do konwersji svg, png to svg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'webp-to-svg': 'webp do konwersji svg, webp to svg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'gif-to-svg': 'gif do konwersji svg, gif to svg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'bmp-to-svg': 'bmp do konwersji svg, bmp to svg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

        'tiff-to-svg': 'tiff do konwersji svg, tiff to svg, konwerter obrazów, png do jpg, jpg do png, konwerter webp',

      },
    },
    title: 'Konwerter Obrazów',
    desc: 'Konwertuj obrazy między JPG, PNG, WEBP, GIF, SVG, TIFF i BMP. Zbiorcza konwersja wielu plików.',
    toConvert: 'do konwersji',
    convertSettings: 'Ustawienia Konwersji',
    detected: 'Wykryto',
    convertTo: 'Konwertuj do',
    converting: 'Konwertowanie…',
    convertToFormat: 'Konwertuj do {format}',
    popularConversions: 'Popularne Konwersje',
    convertingTo: 'Konwertowanie do',
    all: 'Wszystkie',
  },

  resizer: {
    seo: {
      uploadTitle: 'Zmień Rozmiar Obrazu — Zmień Rozmiar JPG, PNG za Darmo | photremium.com',
      uploadDesc: 'Zmieniaj rozmiar obrazów w pikselach lub procentach za darmo online.',
      uploadKeywords: 'zmień rozmiar obrazu, narzędzie do zmiany rozmiaru, zmień rozmiar jpg, zmień rozmiar png',
      workspaceTitle: 'Zmiana Rozmiaru Obrazu — photremium.com',
      workspaceDesc: 'Zmieniaj rozmiar obrazów za darmo online.',
      workspaceKeywords: 'zmień rozmiar obrazu, narzędzie do zmiany rozmiaru',
    },
    title: 'Zmień Rozmiar Obrazu',
    desc: 'Określ rozmiar w pikselach, procentach, centymetrach lub calach i natychmiast zmień rozmiar.',
    toResize: 'do zmiany rozmiaru',
    resizeSettings: 'Ustawienia Rozmiaru',
    resizeBy: 'Zmień rozmiar według:',
    byPixels: 'Piksele',
    byPercentage: 'Procenty',
    byCentimeters: 'Centymetry',
    byInches: 'Cale',
    advanced: 'Zaawansowane',
    lockAspect: 'Zablokuj Proporcje',
    unlockAspect: 'Odblokuj Proporcje',
    dontEnlarge: 'Nie powiększaj, jeśli oryginał jest mniejszy',
    resizing: 'Zmiana rozmiaru…',
    resizeDownload: 'Zmień Rozmiar i Pobierz',
    blog: {
      tocTitle: 'Spis treści',
      title: 'Blog o Zmianie Rozmiaru Obrazów',
      sections: [
        {
          id: 'imgresize-card-1',
          title: '1. Dlaczego warto używać narzędzia do zmiany rozmiaru obrazu?',
          paragraphs: [
            'Narzędzie do zmiany rozmiaru obrazu to oprogramowanie służące do zmiany wymiarów obrazu. Możesz dostosować wysokość, szerokość lub oba parametry, aby uzyskać potrzebny rozmiar. Jest szczególnie przydatne na platformach społecznościowych z limitami wymiarów przesyłanych obrazów.',
          ],
          listTitle: 'Na przykład:',
          bullets: [
            'Post na Instagramie: 1080 x 1080px (kwadrat)',
            'Post na Facebooku: 1200 x 630px',
            'Post na X (Twitter): 1200 x 675px',
            'Relacja Instagram: 1080 x 1920px',
          ],
        },
        {
          id: 'imgresize-card-2',
          title: '2. Dlaczego wybrać nasze narzędzie do zmiany rozmiaru?',
          paragraphs: [
            'Nasze narzędzie AI do zmiany rozmiaru obrazów pozwala skalować obrazy precyzyjnie i bardzo szybko. Działa płynnie na każdym urządzeniu i nie wymaga instalacji aplikacji. Wszystkie funkcje są dostępne online w przeglądarce.',
          ],
          bullets: [
            'Możesz zmieniać rozmiar wielu obrazów jednocześnie (nawet 100+). Na wydajnym urządzeniu możliwe jest także przetworzenie 400–500 obrazów w kilka sekund.',
            'Wszystko przetwarzane jest lokalnie w przeglądarce. Nie musisz wysyłać obrazów na serwer, więc pliki nie opuszczają urządzenia.',
            'Obsługiwane są różne jednostki zmiany rozmiaru.',
            'Możesz zachować proporcje obrazu za pomocą jednego pola wyboru.',
            'Przy wielu obrazach możesz pobierać osobno albo jako ZIP.',
          ],
        },
        {
          id: 'imgresize-card-3',
          title: '3. Instrukcja krok po kroku',
          steps: [
            {
              heading: 'Najpierw wybierz obrazy, których rozmiar chcesz zmienić (jeden lub wiele). Masz kilka sposobów wyboru.',
              bullets: [
                'Przeciągnij i upuść obrazy do pola drop.',
                'Możesz też wkleić obrazy skrótem “Ctrl + V”.',
                'Albo kliknij “Choose Files”, aby wybrać obrazy z eksploratora plików.',
              ],
            },
            {
              heading: 'Następnie wybierz jednostkę zmiany rozmiaru. Dostępne jednostki to:',
              bullets: ['Pixels', 'Percentage', 'Centimeters', 'Inches'],
            },
            {
              heading: 'Po wybraniu jednostki ustaw wysokość i szerokość. Możesz też zablokować proporcje obrazu.',
            },
            {
              heading: 'Jeśli nie chcesz powiększać ponad rozmiar oryginalny, zaznacz “Don’t enlarge if original is smaller”.',
            },
            {
              heading: 'Następnie wybierz opcję pobierania.',
              bullets: [
                'Wybierz ZIP, jeśli chcesz pobrać wszystkie obrazy jako jeden plik zip.',
                'Wybierz “separate”, jeśli chcesz pobierać każdy obraz osobno.',
              ],
            },
            {
              heading: 'Na końcu kliknij “Resize & Download”, aby pobrać obrazy zgodnie z wybraną opcją.',
            },
          ],
        },
        {
          id: 'imgresize-card-4',
          title: '4. Korzyści z narzędzia do zmiany rozmiaru: największą zaletą jest prawidłowe dopasowanie obrazów na stronach internetowych i w postach social media.',
          tocLabel: '4. Korzyści z narzędzia do zmiany rozmiaru',
          bullets: [
            'Lepszy UX: prawidłowy rozmiar i rozmieszczenie obrazów znacząco poprawiają doświadczenie użytkownika.',
            'Wsparcie social media: wiele platform ma limity wymiarów i nasze narzędzie pomaga je spełnić.',
            'Responsywny design: twórcy stron potrzebują wielu rozmiarów obrazów dla różnych urządzeń.',
            'Lepszy wybór: zamiast rozciągać lub agresywnie kadrować obraz, zmiana rozmiaru zwykle daje lepszy efekt.',
          ],
        },
        {
          id: 'imgresize-card-5',
          title: '5. Obsługiwane formaty: nasze narzędzie obsługuje wybór obrazów we wszystkich formatach. Lista obsługiwanych formatów:',
          tocLabel: '5. Obsługiwane formaty',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  cropper: {
    seo: {
      uploadTitle: 'Przytnij Obraz — Przytnij JPG, PNG, GIF za Darmo | photremium.com',
      uploadDesc: 'Łatwo przycinaj obrazy JPG, PNG i GIF za darmo online.',
      uploadKeywords: 'przytnij obraz, narzędzie do przycinania, przytnij jpg, przytnij png',
      workspaceTitle: 'Przycinanie Obrazu — photremium.com',
      workspaceDesc: 'Przycinaj obrazy za darmo online.',
      workspaceKeywords: 'przytnij obraz, narzędzie do przycinania',
    },
    title: 'Przytnij Obraz',
    desc: 'Przycinaj JPG, PNG, GIF i inne za pomocą edytora wizualnego. Proporcje predefiniowane lub dowolne.',
    toCrop: 'do przycięcia',
    cropSettings: 'Ustawienia Przycinania',
    widthPx: 'Szerokość (px)',
    heightPx: 'Wysokość (px)',
    positionX: 'Pozycja X (px)',
    positionY: 'Pozycja Y (px)',
    cropTemplate: 'Szablon Przycinania',
    landscape: 'Poziomy',
    portrait: 'Pionowy',
    square: 'Kwadrat',
    freeform: 'Dowolny',
    cropping: 'Przycinanie…',
    cropDownload: 'Przytnij i Pobierz',
    cropDownloadAll: 'Przytnij i Pobierz Wszystkie',
    saveNext: 'Zapisz i Dalej',
    croppedNofTotal: 'Przycięto {n} z {total}.',
    downloadN: 'Pobierz {n}',
    blog: {
      tocTitle: 'Spis treści',
      title: 'Blog o Przycinaniu Obrazów',
      sections: [
        {
          id: 'imgcrop-card-1',
          title: '1. Dlaczego warto używać narzędzia do przycinania obrazów?',
          paragraphs: [
            'Narzędzie do przycinania obrazów to oprogramowanie służące do przycinania obrazu do pożądanego kształtu. Jest powszechnie używane do zachowania potrzebnej części obrazu i usunięcia zewnętrznych, niechcianych obszarów do dowolnego celu. Narzędzie udostępnia ramkę kadrowania, którą możesz dopasować w miejscu, które chcesz przyciąć.',
          ],
          listTitle: 'Na przykład:',
          bullets: [
            'Wycięcie siebie ze zdjęcia grupowego.',
            'Wycięcie swojego imienia z listy.',
            'Wycięcie paska postępu ze zrzutu ekranu pełnego ekranu.',
          ],
        },
        {
          id: 'imgcrop-card-2',
          title: '2. Dlaczego wybrać nasze narzędzie do przycinania obrazów?',
          paragraphs: [
            'Nasze narzędzie do przycinania obrazów pozwala przycinać obrazy dokładnie i bardzo szybko. Wystarczy dopasować rozmiar ramki kadrowania w miejscu, które chcesz przyciąć na dowolnym obrazie. Przy wyborze obrazu obsługiwane są prawie wszystkie formaty obrazów.',
          ],
          bullets: [
            'Możesz przyciąć tyle obrazów, ile obsługuje Twoje urządzenie. Jeśli masz wydajne urządzenie, możesz nawet przyciąć 100+ obrazów naraz bez lagów i innych problemów.',
            'Twoje obrazy są przetwarzane lokalnie w przeglądarce. Nie trzeba wysyłać żadnych obrazów na nasz serwer, więc żaden obraz nie opuszcza urządzenia. Możesz przycinać prywatne obrazy bez ryzyka bezpieczeństwa.',
            'Wiele narzędzi zgłasza błąd nieprawidłowego formatu obrazu. Nasze narzędzie rozwiązuje ten problem, obsługując prawie wszystkie formaty obrazów.',
            'Jeśli przycinasz wiele obrazów jednocześnie, nasze narzędzie pozwala pobrać przycięte obrazy jako ZIP lub jako osobne pliki — zgodnie z Twoją preferencją.',
          ],
        },
        {
          id: 'imgcrop-card-3',
          title: '3. Instrukcja krok po kroku',
          steps: [
            {
              heading: '1. Najpierw wybierz obraz, który chcesz przyciąć. Nasze narzędzie obsługuje także wybór wielu obrazów jednocześnie.',
              bullets: [
                'Przeciągnij i upuść obrazy do pola upuszczania, aby je przyciąć.',
                'Możesz też wybrać obrazy przez eksplorator plików, klikając przycisk choose files w polu kadrowania.',
                'Obsługiwany jest również skrót Ctrl + V do wklejania obrazów do pola upuszczania.',
              ],
            },
            {
              heading: '2. Następnie dopasuj rozmiar i pozycję ramki kadrowania na obrazie.',
            },
            {
              heading: '3. Możesz też ustawić ramkę kadrowania ręcznie, wpisując wysokość, szerokość, pozycję poziomą i pionową.',
            },
            {
              heading: '4. Możesz również użyć kilku gotowych szablonów:',
              bullets: [
                'Landscape(16:9)',
                'Portrait(9:16)',
                'Square(1:1)',
              ],
            },
            {
              heading: '5. Następnie wybierz jedną z opcji pobierania.',
              bullets: [
                'ZIP: Wybierz tę opcję, jeśli przycinasz wiele obrazów i chcesz pobrać wszystkie przycięte obrazy jako jeden plik.',
                'Separate: Jeśli chcesz pobrać wszystkie przycięte obrazy osobno, wybierz tę opcję przełącznikiem.',
              ],
            },
            {
              heading: '6. Następnie kliknij przycisk Crop & Download, aby pobrać wszystkie przycięte obrazy zgodnie z ustawionymi wymiarami.',
            },
          ],
        },
        {
          id: 'imgcrop-card-4',
          title: '4. Korzyści z przycinania obrazów: narzędzie do przycinania obrazów daje wiele korzyści w świecie cyfrowym. Część z nich opisano poniżej:',
          tocLabel: '4. Korzyści z przycinania obrazów',
          bullets: [
            'Dopasowanie obrazu do ramki: Narzędzie do przycinania pomaga prawidłowo umieścić obraz w ramce. Taka ramka może znajdować się na stronie internetowej lub dowolnej platformie społecznościowej.',
            'Poprawa UX: Ponieważ prawidłowe rozmieszczenie obrazów poprawia doświadczenie użytkownika, przycinanie obrazów znacząco poprawia UX.',
            'Usuwanie niechcianych obramowań: Możesz usunąć niepotrzebne obramowania obrazu, aby go dopracować.',
            'Wydzielenie pożądanego obiektu: Możesz także oddzielić siebie ze zdjęcia grupowego.',
            'Oszczędność miejsca: Przycinanie obrazu oszczędza pamięć, bo usuwany jest zbędny obszar, a pozostaje tylko potrzebna część.',
            'Optymalizacja prezentacji: Jeśli zwykła prezentacja z 10 nieprzyciętymi obrazami zajmuje około 30MB, ta sama prezentacja z obrazami przyciętymi może zajmować około 10MB.',
          ],
        },
        {
          id: 'imgcrop-card-5',
          title: '5. Obsługiwane formaty:',
          formats: ['.jpg', '.jpeg', '.png', '.gif', '.webp', '.svg', '.avif', '.heic', '.heif', '.jxl', '.bmp', '.ico', '.tiff', '.tif', '.jfif', '.jpe', '.pjpeg', '.pjp', '.apng', '.svgz', '.xbm'],
        },
      ],
    },
  },

  photoEditor: {
    seo: {
      title: 'Edytor Zdjęć Online — Bezpłatna Edycja z Tekstem, Efektami, Ramkami | photremium.com',
      desc: 'Edytuj zdjęcia online za darmo — dodawaj tekst, efekty, ramki, naklejki. Działa w przeglądarce.',
      keywords: 'edytor zdjęć, edytor zdjęć online, edycja zdjęć online za darmo',
    },
    title: 'Edytor Zdjęć',
    desc: 'Upiększaj swoje zdjęcia tekstem, efektami, ramkami i naklejkami.',
    toEdit: 'do edycji',
    textTypography: 'Tekst i Typografia',
    textTypographyDesc: 'Dodawaj tekst z różnymi czcionkami, kolorami, cieniami i opcjami pozycji.',
    filtersEffects: 'Filtry i Efekty',
    filtersEffectsDesc: 'Stosuj profesjonalne filtry i reguluj jasność, kontrast i nasycenie.',
    framesStickers: 'Ramki i Naklejki',
    framesStickersDesc: 'Wybieraj piękne ramki i zabawne naklejki, aby wzbogacić swoje obrazy.',
  },

  removeBg: {
    seo: {
      uploadTitle: 'Darmowe Usuwanie Tła Obrazu | photremium.com',
      uploadDesc: 'Szybko usuwaj tło obrazu z wysoką precyzją. Darmowe narzędzie do usuwania tła online.',
      uploadKeywords: 'usuń tło, usuwanie tła, usuń tło obrazu, przezroczyste tło',
      workspaceTitle: 'Usuwanie Tła — photremium.com',
      workspaceDesc: 'Usuń tło obrazu za darmo online.',
      workspaceKeywords: 'usuń tło, przezroczyste tło',
    },
    title: 'Usuń Tło',
    desc: 'Natychmiast usuwaj tło obrazu dzięki zaawansowanemu wykrywaniu krawędzi. 100% bezpłatne, działa w przeglądarce.',
    toRemoveBg: 'do usunięcia tła',
    backgroundRemover: 'Narzędzie do Usuwania Tła',
    processingProgress: 'Postęp Przetwarzania',
    processingNImages: 'Przetwarzanie {n} obrazów…',
    allNProcessed: 'Wszystkie {n} obrazów zostało przetworzonych!',
    nOfTotalDone: '{n} / {total} gotowe',
    fileName: 'Nazwa Pliku',
    dimensions: 'Wymiary',
    status: 'Status',
    statusDone: '✓ Gotowe',
    statusProcessing: '⏳ Przetwarzanie',
    statusError: '✗ Błąd',
    statusPending: '⏸ Oczekuje',
    badgeDone: 'Gotowe',
    badgeProcessing: 'Przetwarzanie…',
    badgeError: 'Błąd',
    removingBg: 'Usuwanie tła…',
    retry: 'Ponów',
    downloading: 'Pobieranie…',
    nextImage: 'Następny Obraz',
  },

  watermark: {
    seo: {
      uploadTitle: 'Znak Wodny na Obrazie — Dodaj Tekstowy i Logo Znak Wodny za Darmo | photremium.com',
      uploadDesc: 'Dodawaj tekstowe lub graficzne znaki wodne do zdjęć w kilka sekund. Bezpłatnie, szybko.',
      uploadKeywords: 'znak wodny na obrazie, dodaj znak wodny, tekstowy znak wodny',
      workspaceTitle: 'Znak Wodny na Obrazie — photremium.com',
      workspaceDesc: 'Dodawaj znaki wodne do obrazów za darmo online.',
      workspaceKeywords: 'znak wodny na obrazie, dodaj znak wodny',
    },
    title: 'Znak Wodny na Obrazie',
    desc: 'Dodawaj tekstowe lub logotypowe znaki wodne do obrazów. Dostosuj czcionkę, krycie, rozmiar i pozycję.',
    toWatermark: 'do dodania znaku wodnego',
    watermarkTools: 'Narzędzia Znaku Wodnego',
    addText: 'Dodaj Tekst',
    addImage: 'Dodaj Obraz',
    layersN: 'Warstwy ({n})',
    noLayers: 'Nie dodano jeszcze żadnych warstw',
    textLayer: 'Warstwa Tekstowa',
    imageLayer: 'Warstwa Obrazu',
    watermarkDownloadAll: 'Dodaj Znak i Pobierz Wszystkie',
    watermarkDownload: 'Dodaj Znak i Pobierz',
    nextImage: 'Następny Obraz',
    selectToEdit: 'Wybierz dowolny obraz lub tekst, aby rozpocząć edycję',
    bold: 'Pogrubienie',
    italic: 'Kursywa',
    underline: 'Podkreślenie',
    bgColor: 'Kolor Tła',
    textColor: 'Kolor Tekstu',
    alignLeft: 'Wyrównaj do Lewej',
    alignCenter: 'Wyśrodkuj',
    alignRight: 'Wyrównaj do Prawej',
    opacity: 'Krycie',
    stroke: 'Obrys',
    strokeWidth: 'Szerokość Obrysu',
    strokeColor: 'Kolor Obrysu',
    tileRepeat: 'Kafelki/Powtórzenie',
    tilePattern: 'Wzór Kafelka',
    spacing: 'Odstęp',
    snapToCenter: 'Przyciągnij do Środka',
    duplicate: 'Duplikuj',
    delete: 'Usuń',
    flipHorizontal: 'Odwróć Poziomo',
    flipVertical: 'Odwróć Pionowo',
    rotateLeft: 'Obróć w Lewo',
    rotateRight: 'Obróć w Prawo',
    cornerRadius: 'Promień Narożnika',
    borderStroke: 'Ramka/Obrys',
    borderWidth: 'Szerokość Ramki',
    color: 'Kolor',
    style: 'Styl',
    hide: 'Ukryj',
    show: 'Pokaż',
    lock: 'Zablokuj',
    unlock: 'Odblokuj',
    solid: 'Ciągła',
    dashed: 'Przerywana',
    dotted: 'Kropkowana',
    double: 'Podwójna',
    tileSingle: 'Pojedyncza',
    tile2x2: 'Siatka 2×2',
    tile3x3: 'Siatka 3×3',
    removeAllConfirm: 'Usunąć wszystkie obrazy i znaki wodne?',
    dimMismatch: 'Przesłane obrazy mają różne wymiary. Dla najlepszych wyników prześlij obrazy o tej samej rozdzielczości.',
    clearBackground: 'Wyczyść Tło',
    typeHere: 'Wpisz tutaj...',
    linkCorners: 'Połącz Narożniki',
    separateCorners: 'Rozdziel Narożniki',
    blog: {
      tocTitle: 'Spis treści',
      sections: [
        {
          id: 'wm-blog-intro',
          tocLabel: 'Przegląd narzędzia do znaków wodnych',
          title: 'Jak dodać znak wodny do swoich obrazów online — kompletny przewodnik po narzędziu do znaków wodnych Photremium',
          paragraphs: [
            'Właśnie skończyłeś edycję pięknej fotografii. Może to zdjęcie produktu dla Twojego sklepu, portret z sesji klienta albo dzieło sztuki cyfrowej, nad którym spędziłeś wiele godzin, dopracowując każdy detal. I pojawia się pytanie, przed którym w końcu staje każdy twórca: jak chronić tę pracę, zanim ją udostępnisz?',
            'Większość profesjonalistów dochodzi do jednego rozwiązania: znaku wodnego — i nie bez powodu. Prawidłowo umieszczony znak wodny działa jak trwały podpis Twojej pracy, dzięki czemu jest możliwa do śledzenia, oznaczona marką i znacznie trudniejsza do kradzieży.',
            'Problem, na który trafia większość osób, jest jednak prosty: narzędzia dostępne online są albo zbyt nieporęczne, albo ukryte za subskrypcją, albo tworzą tak ciężki znak wodny, że całkowicie psują obraz.',
            'Narzędzie Watermark Image od Photremium zostało stworzone, aby to wszystko naprawić. To w pełni oparte na przeglądarce, darmowe i niewymagające konta środowisko do znakowania wodnego, które działa bezpośrednio w Twojej przeglądarce, bez wysyłania plików na serwer. Wszystko pozostaje lokalnie, wszystko działa szybko, a poziom kontroli twórczej dorównuje temu, czego można oczekiwać od aplikacji desktopowej. W tym przewodniku pokażemy dokładnie, jak to działa, dla kogo jest przeznaczone i jak uzyskiwać najlepsze możliwe rezultaty — za każdym razem.',
          ],
        },
        {
          id: 'wm-blog-what-is',
          tocLabel: 'Czym jest znak wodny',
          title: 'Czym jest znak wodny i dlaczego ma znaczenie?',
          paragraphs: [
            'Zanim przejdziemy do samego narzędzia, warto zrozumieć, co robi znak wodny i dlaczego tak wielu fotografów, projektantów i twórców treści uważa go za coś, z czego nie można zrezygnować.',
            'Znak wodny to widoczna nakładka dodawana do obrazu — zwykle tekst, logo lub symbol praw autorskich — która identyfikuje twórcę albo właściciela treści. W przeciwieństwie do metadanych (ukrytych w pliku i możliwych do usunięcia w kilka sekund) znak wodny jest wizualnie wbudowany w sam obraz. Nie da się go po prostu kliknąć prawym przyciskiem i usunąć bez zauważalnego pogorszenia jakości obrazu.',
          ],
          subSections: [
            {
              title: 'Dlaczego twórcy używają znaków wodnych',
              paragraphs: [
                'Praktyczne powody znakowania obrazów sprowadzają się do trzech głównych kwestii.',
              ],
              bullets: [
                'Identyfikacja własności. Gdy Twoja praca krąży po mediach społecznościowych, tablicach Pinterest albo zostaje osadzona w wpisach blogowych, pierwotna atrybucja często znika. Znak wodny sprawia, że Twoje imię albo marka podążają za obrazem, gdziekolwiek trafi.',
                'Ochrona przed kradzieżą. Większość przypadkowych złodziei obrazów szuka najłatwiejszej drogi. Profesjonalnie wyglądający znak wodny, zwłaszcza dobrze umieszczony i lekko przezroczysty, wysyła jasny sygnał: ten obraz należy do kogoś, kto dba o swoją pracę.',
                'Ochrona portfolio klienta. Fotografowie pokazujący podglądy klientom przed końcową płatnością często używają znaków wodnych, aby klienci nie korzystali z podglądu bez opłacenia faktury. Subtelny znak wodny robi to bez nadmiernego rozpraszania przy ocenie podglądu.',
              ],
            },
            {
              title: 'Kto powinien znakować swoje obrazy',
              paragraphs: [
                'Jeśli należysz do którejkolwiek z poniższych grup, znakowanie obrazów przed publikacją online nie jest opcjonalne — jest niezbędne:',
              ],
              bullets: [
                'Fotografowie freelancerzy udostępniający galerie klientom',
                'Graficy dystrybuujący próbki portfolio',
                'Sprzedawcy e-commerce pokazujący zdjęcia produktów przed umowami licencyjnymi',
                'Artyści cyfrowi publikujący swoje prace w mediach społecznościowych',
                'Blogerzy i twórcy treści, których obrazy są regularnie ponownie wykorzystywane',
                'Autorzy zdjęć stockowych budujący rozpoznawalną markę',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-workspace',
          tocLabel: 'Panele obszaru roboczego',
          title: 'Wewnątrz narzędzia do znaków wodnych Photremium: trzy-panelowy obszar roboczy stworzony do rzeczywistych workflow',
          paragraphs: [
            'To, co wyróżnia narzędzie do znaków wodnych Photremium na tle podstawowych internetowych watermarkerów, to konstrukcja obszaru roboczego. Zamiast prostego podejścia „wpisz tekst, wybierz pozycję, gotowe”, narzędzie oferuje układ trzech paneli, który przypomina profesjonalne oprogramowanie do projektowania — z tą różnicą, że działa całkowicie w przeglądarce i nie wymaga instalacji.',
          ],
          subSections: [
            {
              title: 'Lewy panel canvas',
              paragraphs: [
                'Panel canvas zajmuje największą część ekranu i pokazuje dokładnie, jak wygląda obraz po zastosowaniu znaku wodnego w czasie rzeczywistym. Każda zmiana — regulacja krycia, przesuwanie warstwy tekstowej, zmiana rozmiaru logo — od razu pojawia się na canvasie. Nie ma przycisku „podgląd”, który trzeba kliknąć. To, co widzisz, to dokładnie to, co otrzymasz.',
                'Canvas zawiera też wbudowany pasek powiększenia, który pozwala przybliżać obraz do precyzyjnego wyrównania i oddalać go, by zobaczyć całość. Funkcja dopasowania do ekranu automatycznie oblicza najlepszą początkową skalę na podstawie rozmiaru ekranu, więc nawet obrazy w wysokiej rozdzielczości otwierają się w wygodnym rozmiarze roboczym. Prowadnice wyrównania pojawiają się dynamicznie, gdy przeciągasz warstwę blisko poziomego lub pionowego środka obrazu, zatrzaskując znak wodny dokładnie na środku z satysfakcjonującą precyzją, jaką zwykle daje tylko Photoshop.',
              ],
            },
            {
              title: 'Prawy panel ustawień',
              paragraphs: [
                'Prawy panel to centrum sterowania. Tutaj zarządzasz warstwami znaku wodnego, dostosowujesz ich wygląd i uruchamiasz finalny eksport. Na desktopie pozostaje przypięty do prawej strony ekranu. Na urządzeniach mobilnych wysuwa się od dołu jako dolny panel — uruchamiany pływającym przyciskiem zębatki — dzięki czemu nigdy nie zasłania canvasu podczas pracy.',
                'W prawym panelu znajdziesz menedżer warstw, który wyświetla każdy dodany element znaku wodnego. Każdy wpis pokazuje typ warstwy (tekst lub obraz), jej aktualną nazwę albo treść oraz trzy szybkie przyciski: przełącznik widoczności (ikona oka), przełącznik blokady, który zamraża pozycję warstwy podczas pracy nad innymi, oraz przycisk usuwania.',
              ],
            },
            {
              title: 'Lewy pasek podglądu (tryb wielu obrazów)',
              paragraphs: [
                'Gdy pracujesz z wieloma obrazami naraz — np. serią zdjęć produktu albo pełną sesją portretową — po lewej stronie ekranu pojawia się pionowy pasek miniatur. To kolejka obrazów, pokazująca miniaturowe podglądy każdego wgranego pliku. Kliknięcie dowolnej miniatury natychmiast przełącza canvas na ten obraz, dzięki czemu możesz sprawdzać wygląd znaku wodnego w różnych kompozycjach bez utraty ustawień warstw.',
                'Pasek pokazuje też rozmiar pliku w KB lub MB oraz etykietę formatu (JPG, PNG, WEBP), więc od razu wiesz, z czym pracujesz.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-steps',
          tocLabel: 'Krok po kroku',
          title: 'Krok po kroku: jak dodać znak wodny do obrazu w Photremium',
          paragraphs: [
            'Ten przewodnik opiera się bezpośrednio na tym, jak narzędzie działa od środka — od systemu przesyłania metodą przeciągnij i upuść po silnik renderowania canvasu, który zapisuje znak wodny na obrazie na stałe przed pobraniem.',
          ],
          steps: [
            {
              heading: 'Krok 1 — prześlij swój obraz/obrazy',
              paragraphsBefore: [
                'Wejdź na photremium.com/watermark-image. Trafisz na ekran przesyłania z prostym obszarem przeciągnij-i-upuść na środku strony.',
                'Masz trzy sposoby dodania obrazu do narzędzia:',
              ],
              bullets: [
                'Przeciągnij i upuść. Przeciągnij jeden lub więcej plików graficznych z pulpitu bezpośrednio do strefy upuszczania. Narzędzie akceptuje każdy standardowy format obrazu — JPEG, PNG, WEBP i inne. Gdy przeciągasz pliki nad obszarem roboczym, wokół całego obszaru pojawia się fioletowa ramka z komunikatem „Drop images to add for watermarking”, więc wiesz, że upuszczenie zostało zarejestrowane.',
                'Kliknij, aby przeglądać. Kliknij przycisk „Choose Files” w strefie upuszczania, aby otworzyć systemowy selektor plików. Możesz zaznaczyć wiele plików jednocześnie, używając Ctrl+Click (Windows) lub Cmd+Click (Mac).',
                'Wklej ze schowka. Jeśli skopiowałeś obraz do schowka — zrzut ekranu, innej aplikacji albo przeglądarki — po prostu naciśnij Ctrl+V (lub Cmd+V na Macu) na stronie znaku wodnego, a obraz zostanie załadowany bezpośrednio do obszaru roboczego. Działa to nawet wtedy, gdy wczytano już wiele obrazów.',
              ],
              paragraphsAfter: [
                'Gdy tylko załaduje się pierwszy obraz, obszar roboczy przechodzi ze strony przesyłania do pełnego edytora trzy-panelowego, a canvas pokazuje obraz w automatycznie obliczonym powiększeniu dopasowanym do ekranu.',
              ],
            },
            {
              heading: 'Krok 2 — dodaj warstwę znaku wodnego w formie tekstu',
              paragraphsBefore: [
                'Kliknij fioletowy przycisk „Add Text” w prawym panelu. Na canvasie pojawi się nowa warstwa tekstowa z domyślnym tekstem zastępczym „Type here...” już zaznaczonym.',
                'Możesz od razu zacząć pisać. Tekst pojawia się na canvasie na biało, w Arialu, w domyślnym rozmiarze dopasowanym do wymiarów obrazu. Z górnego paska narzędzi, który pojawia się po zaznaczeniu warstwy tekstowej, możesz dostosować każdy aspekt tekstu:',
              ],
              bullets: [
                'Rodzina czcionek — wybierz spośród 12 wbudowanych fontów, w tym Arial, Georgia, Impact, Brush Script MT, Comic Sans MS i innych',
                'Rozmiar czcionki — wpisz własną wartość w pikselach bezpośrednio lub użyj przycisków zwiększania i zmniejszania',
                'Pogrubienie, kursywa, podkreślenie — włącz dowolną kombinację tych stylów',
                'Kolor tekstu — kliknij próbkę koloru, aby otworzyć selektor i wybrać dowolny kolor hex',
                'Kolor tła — dodaj kolorowe tło za tekstem, aby uzyskać wygląd etykiety albo odznaki',
                'Obrys — ustaw szerokość i kolor obrysu, aby uzyskać maksymalną czytelność na jasnych i ciemnych obrazach',
                'Krycie — ustaw od 0% (niewidoczne) do 100% (w pełni nieprzezroczyste); większość znaków wodnych mieści się między 30% a 60%',
                'Wyrównanie — wyrównaj tekst do lewej, środka albo prawej w obrębie jego pola',
                'Obrót — obracaj warstwę tekstową pod dowolnym kątem, z magnetycznymi punktami przy 0°, 90°, 180° i 270° dla szybkiego ustawienia pod prostym kątem',
              ],
              paragraphsAfter: [
                'Aby przesunąć tekst, kliknij go i przeciągnij w dowolne miejsce na canvasie. Do precyzyjnego ustawiania piksel po pikselu użyj strzałek na klawiaturze (przytrzymaj Shift, aby przesuwać o 10 pikseli). Aby zmienić rozmiar pola tekstowego, przeciągnij dowolny z ośmiu uchwytów zmiany rozmiaru (rogi i krawędzie), które pojawiają się wokół zaznaczonej warstwy.',
              ],
            },
            {
              heading: 'Krok 3 — dodaj warstwę znaku wodnego w formie obrazu (logo)',
              paragraphsBefore: [
                'Jeśli chcesz użyć logo, podpisu albo dowolnego obrazu jako znaku wodnego zamiast tekstu — albo obok niego — kliknij niebieski przycisk „Add Image” w prawym panelu. Otworzy się selektor plików, abyś mógł wybrać plik obrazu znaku wodnego z urządzenia.',
                'Narzędzie automatycznie skaluje obraz znaku wodnego do około 30% szerokości canvasu, zachowując oryginalne proporcje, i centruje go na canvasie. Stamtąd możesz przeciągnąć go w dowolne miejsce, zmieniać jego rozmiar uchwytami narożnymi (które zachowują proporcje) albo obracać go za pomocą specjalnego uchwytu obrotu, który pojawia się nad zaznaczoną warstwą.',
                'Dla warstw znaku wodnego typu obrazowego prawy panel pokazuje dodatkowe opcje:',
              ],
              bullets: [
                'Krycie — tak samo jak w warstwach tekstowych, idealne dla przezroczystych logo PNG',
                'Odbicie poziome / Odbicie pionowe — w razie potrzeby odwróć znak wodny lustrzanie',
                'Szerokość obramowania, kolor obramowania i styl obramowania — dodaj widoczną ramkę wokół logo znakującego',
                'Promień narożników — zaokrąglij rogi logo, jednolicie albo z osobną kontrolą każdego rogu',
                'Obrót — ten sam płynny sposób obracania co w warstwach tekstowych',
              ],
            },
            {
              heading: 'Krok 4 — skonfiguruj kafelkowanie (opcjonalnie)',
              paragraphsBefore: [
                'Jedną z bardziej zaawansowanych funkcji narzędzia jest kafelkowanie — możliwość powtarzania znaku wodnego na całym obrazie w układzie siatki. Jest to szczególnie przydatne, gdy chcesz uczynić obraz nieprzydatnym do ponownej publikacji, a nie tylko oznaczonym marką.',
                'Przy zaznaczonej warstwie poszukaj opcji tile w pasku narzędzi. Możesz ustawić:',
              ],
              bullets: [
                'Brak — pojedyncze umieszczenie (domyślne)',
                'Siatka 2×2 — powtarza znak wodny w układzie 2 kolumny × 2 wiersze',
                'Siatka 3×3 — powtarza w siatce 3×3, aby uzyskać gęstsze pokrycie',
              ],
              paragraphsAfter: [
                'Możesz też dostosować odstęp między kafelkami, który kontroluje przerwę między każdą powtórzoną instancją. Canvas pokazuje duchowe podglądy wszystkich skopiowanych kafelków, dzięki czemu możesz zobaczyć pełny wzór pokrycia przed pobraniem.',
              ],
            },
            {
              heading: 'Krok 5 — użyj menedżera warstw dla wielu znaków wodnych',
              paragraphsBefore: [
                'Możesz dodać dowolną liczbę warstw — swobodnie łącząc tekstowe i obrazowe znaki wodne. Menedżer warstw w prawym panelu wyświetla je wszystkie. Możesz:',
              ],
              bullets: [
                'Pokazywać/ukrywać poszczególne warstwy za pomocą ikony oka — przydatne do przełączania się między różnymi wersjami znaku wodnego bez usuwania czegokolwiek',
                'Zablokować warstwę, aby zapobiec przypadkowemu przesunięciu podczas pracy nad innymi warstwami',
                'Usunąć warstwę na stałe',
              ],
              paragraphsAfter: [
                'Kliknięcie dowolnego wpisu warstwy na liście zaznacza go jednocześnie na canvasie, co ułatwia przełączanie między warstwami bez szukania ich na obrazie.',
              ],
            },
            {
              heading: 'Krok 6 — przełączaj się między wieloma obrazami',
              paragraphsBefore: [
                'Jeśli przesłałeś więcej niż jeden obraz, użyj paska miniatur po lewej stronie, aby przełączać aktywny obraz canvasu. Skonfigurowane warstwy znaku wodnego są stosowane uniwersalnie — zostaną wyrenderowane na każdym obrazie w Twojej partii podczas eksportu.',
                'Narzędzie wykonuje też kontrolę spójności rozdzielczości w całej partii. Jeśli obrazy mają znacznie różne wymiary (ponad 5% różnicy szerokości lub wysokości), pojawi się ostrzeżenie informujące, że pozycja znaku wodnego może wyglądać inaczej na poszczególnych obrazach z powodu różnicy wielkości. Silnik obsługuje to płynnie dzięki algorytmowi proporcjonalnego przeliczania pozycji: oblicza położenie znaku wodnego jako procent wymiarów obrazu referencyjnego i stosuje tę samą proporcjonalną pozycję do każdego innego obrazu w partii, zachowując wizualny zamysł nawet przy różnych rozdzielczościach.',
              ],
            },
            {
              heading: 'Krok 7 — ustaw preferencje pobierania',
              paragraphsBefore: [
                'W przypadku pojedynczego obrazu kliknij przycisk „Download” pod canvasem, aby zapisać bezpośrednio obraz ze znakiem wodnym. Nazwa pliku zostanie automatycznie ustawiona na oryginalną nazwę z dopiskiem „-watermarked” przed rozszerzeniem. Obrazy JPEG są eksportowane z jakością 0.95 — na tyle wysoką, że przy zwykłym rozmiarze oglądania są nie do odróżnienia od oryginału. Obrazy PNG są eksportowane jako bezstratne PNG.',
                'W przypadku wsadów (wiele obrazów) masz dwa tryby pobierania, które możesz wybrać w prawym panelu:',
              ],
              bullets: [
                'Plik ZIP — wszystkie obrazy ze znakiem wodnym są pakowane do jednego archiwum ZIP, które pobierzesz jednym kliknięciem. Narzędzie dynamicznie ładuje JSZip, aby obsłużyć kompresję.',
                'Osobne pliki — każdy obraz pobiera się jako oddzielny plik z krótką przerwą między pobraniami, aby uniknąć ograniczeń przeglądarki.',
              ],
            },
            {
              heading: 'Krok 8 — pobierz i sprawdź',
              paragraphsBefore: [
                'Po kliknięciu przycisku pobierania (lub przycisku „Watermark & Download All” dla wsadów) narzędzie renderuje każdy obraz na ukrytym elemencie HTML5 canvas w pełnej natywnej rozdzielczości — nie w skali podglądu, którą widzisz na ekranie. Oznacza to, że wyeksportowany obraz ma 100% oryginalnych wymiarów pikselowych, a znak wodny jest narysowany w proporcjonalnie poprawnym rozmiarze. Otwórz pobrany plik i przybliż, aby sprawdzić, czy pozycja i jakość znaku wodnego odpowiadają Twoim oczekiwaniom.',
                'Jeśli coś wygląda nie tak, po prostu wróć do obszaru roboczego — Twoje warstwy wciąż tam są — popraw ustawienia i pobierz ponownie.',
              ],
            },
          ],
        },
        {
          id: 'wm-blog-tips',
          tocLabel: 'Wskazówki pro',
          title: 'Wskazówki pro, aby uzyskać najlepsze rezultaty',
          bullets: [
            'Używaj półprzezroczystego logo PNG, jeśli chcesz uzyskać najbardziej profesjonalny efekt. Znak wodny z logo na przezroczystym tle i kryciem 40–50% wygląda znacznie lepiej niż zwykły tekst. Wyeksportuj logo z narzędzia projektowego jako PNG z przezroczystością alfa, zanim użyjesz go jako warstwy obrazu.',
            'Umieszczaj znak wodny tam, gdzie jego przycięcie odbiera wartość. Prawy dolny róg to najczęstsze miejsce znaku wodnego — i najłatwiejsze do wycięcia. Dla lepszej ochrony rozważ umieszczenie znaku wodnego na wizualnie ważnym obszarze obrazu, na przykład na twarzy, detalu produktu albo punkcie centralnym. Opcja diagonal tile jest jeszcze trudniejsza do usunięcia bez wyraźnego pogorszenia obrazu.',
            'Korzystaj z funkcji blokady podczas pracy z wieloma warstwami. Gdy jesteś zadowolony z głównej pozycji znaku wodnego, zablokuj tę warstwę przed dodawaniem kolejnych. Dzięki temu nie przesuniesz jej przypadkowo, pracując nad innymi elementami.',
            'Testuj na jasnych i ciemnych fragmentach obrazu. Biały znak wodny jest niewidoczny na jasnym niebie, ale doskonale czytelny na ciemnym cieniu. Dodaj delikatny obrys albo kolor tła, aby zachować czytelność niezależnie od tego, co znajduje się pod znakiem wodnym.',
            'Skróty klawiaturowe zawsze oszczędzają czas. Strzałki przesuwają zaznaczoną warstwę o jeden piksel na raz. Shift+Strzałka przesuwa o dziesięć pikseli. Klawisz Delete natychmiast usuwa zaznaczoną warstwę. Te skróty sprawiają, że dopracowanie położenia jest dużo szybsze niż przeciąganie.',
          ],
        },
        {
          id: 'wm-blog-privacy',
          tocLabel: 'Prywatność i bezpieczeństwo',
          title: 'Prywatność i bezpieczeństwo: dlaczego przetwarzanie w przeglądarce ma znaczenie',
          paragraphs: [
            'Jedną z największych obaw wielu twórców korzystających z narzędzi online jest to, gdzie właściwie trafiają ich obrazy. W przypadku narzędzi działających po stronie serwera obraz jest wysyłany na serwer dostawcy, tam przetwarzany, a następnie odsyłany z powrotem. Oznacza to, że Twoje nieopublikowane prace, zdjęcia klientów albo wrażliwe obrazy produktów przechodzą przez cudzą infrastrukturę.',
            'Narzędzie do znaków wodnych Photremium przetwarza wszystko lokalnie w Twojej przeglądarce. Obrazy są ładowane do pamięci Twojego urządzenia za pomocą File API przeglądarki i nigdy nie są przesyłane przez internet. Renderowanie znaku wodnego odbywa się na elemencie HTML5 canvas działającym w JavaScript, całkowicie w obrębie karty przeglądarki. Gdy zamkniesz stronę albo klikniesz „Start Over”, wszystkie dane obrazu są zwalniane z pamięci i usuwane. Nic nie jest przechowywane poza Twoim własnym urządzeniem.',
          ],
        },
        {
          id: 'wm-blog-summary',
          tocLabel: 'Podsumowanie końcowe',
          title: 'Dlaczego narzędzie do znaków wodnych Photremium zasługuje na stałe miejsce w Twoim workflow',
          paragraphs: [
            'W internecie dostępnych jest dziesiątki narzędzi do znakowania obrazów. To, co odróżnia narzędzie warte zapisania w zakładkach od tego, o którym można zapomnieć, to zwykle połączenie szybkości, kontroli i wiarygodności.',
            'Szybkość ma znaczenie, bo znakowanie wodne nie powinno znacząco wydłużać Twojego workflow po obróbce. Narzędzie Photremium ładuje się natychmiast, przetwarza lokalnie i eksportuje w pełnej rozdzielczości w kilka sekund — nawet przy dużych partiach. Nie ma czekania na przetwarzanie po stronie serwera, nie ma kolejki i nie ma czasu renderowania, który rośnie wraz z liczbą osób online jednocześnie.',
            'Kontrola ma znaczenie, bo źle wyglądający znak wodny jest gorszy niż jego brak — sprawia, że marka wygląda nieprofesjonalnie. System warstw, sterowanie poszczególnymi właściwościami na pasku narzędzi, podgląd canvasu w czasie rzeczywistym i obsługa skrótów klawiaturowych razem dają poziom kontroli naprawdę porównywalny z dedykowanym oprogramowaniem desktopowym.',
            'Wiarygodność ma znaczenie, bo Twoje nieopublikowane prace są cenne. Świadomość, że obrazy nigdy nie opuszczają internetu i nie trafiają na serwer zewnętrzny, oznacza, że możesz znakować zdjęcia klientów, niewydane obrazy produktów i wrażliwe prace twórcze bez obaw o obsługę danych, naruszenia po stronie serwera czy zmiany zasad dostawcy chmurowego.',
            'Niezależnie od tego, czy dodajesz szybki komunikat praw autorskich do jednego zdjęcia, czy przetwarzasz całą sesję 200 obrazów przed udostępnieniem galerii klientowi, narzędzie Watermark Image od Photremium daje Ci wszystko, czego potrzebujesz, aby zrobić to dobrze — całkowicie za darmo, całkowicie prywatnie i z wystarczającą elastycznością twórczą, by znak wodny wyglądał jak naturalna część obrazu, a nie coś przyklejonego na wierzchu.',
            'Wejdź na photremium.com/watermark-image i wypróbuj je. Pierwszy obraz ze znakiem wodnym jest dosłownie oddalony o trzydzieści sekund.',
            'Photremium oferuje zestaw opartych na przeglądarce narzędzi do edycji i przetwarzania obrazów. Wszystkie narzędzia działają lokalnie w przeglądarce — Twoje obrazy pozostają na Twoim urządzeniu.',
          ],
        },
      ],
    },
  },

  qrGenerator: {
    seo: {
      inputTitle: 'Generator Kodów QR — Generuj i Dostosuj za Darmo | photremium.com',
      inputDesc: 'Generuj niestandardowe kody QR dla URL, tekstu, WiFi, kontaktów, e-maila i Google Maps.',
      inputKeywords: 'generator kodów qr, stwórz kod qr, niestandardowy kod qr',
      customizeTitle: 'Dostosuj Kod QR — photremium.com',
      customizeDesc: 'Dostosuj styl, kolory, ramkę i logo swojego kodu QR. Pobierz jako PNG, JPG, SVG, WEBP lub PDF.',
      customizeKeywords: 'dostosuj kod qr, styl kodu qr',
    },
    title: 'Generator Kodów QR',
    desc: 'Generuj, dostosowuj i pobieraj kody QR dla URL, tekstu, WiFi, kontaktów, e-maila i map.',
    generate: 'Generuj',
    scanQrCode: 'Skanuj Kod QR',
    tabUrl: 'Link / URL',
    tabText: 'Tekst',
    tabWifi: 'WiFi',
    tabContact: 'Kontakt',
    tabEmail: 'Gmail',
    tabMaps: 'Google Maps',
    enterUrl: 'Wprowadź URL',
    enterText: 'Wprowadź tekst',
    networkName: 'Nazwa Sieci (SSID)',
    password: 'Hasło',
    encryption: 'Szyfrowanie',
    hiddenNetwork: 'Ukryta Sieć',
    contactName: 'Nazwa Kontaktu (opcjonalnie)',
    phoneNumber: 'Numer Telefonu',
    emailAddress: 'Adres E-mail',
    subject: 'Temat (opcjonalnie)',
    body: 'Treść (opcjonalnie)',
    searchLocation: 'Szukaj lokalizacji',
    urlPlaceholder: 'https://example.com',
    textPlaceholder: 'Wpisz tekst tutaj…',
    wifiNamePlaceholder: 'Moje WiFi',
    passwordPlaceholder: 'hasło',
    contactPlaceholder: 'Jan Kowalski',
    phonePlaceholder: '+48 123 456 789',
    emailPlaceholder: 'example@gmail.com',
    subjectPlaceholder: 'temat',
    bodyPlaceholder: 'treść wiadomości…',
    locationPlaceholder: 'Szukaj miasta, adresu, miejsca…',
    wpaWpa2: 'WPA / WPA2',
    wep: 'WEP',
    none: 'Brak',
    characters: 'znaków',
    generateCustomize: 'Generuj i Dostosuj',
    editQrData: 'Edytuj Dane QR',
    styleShape: 'Styl i Kształt',
    colorTab: 'Kolory',
    framesTab: 'Ramki',
    logoTab: 'Logo',
    templatesTab: 'Szablony',
    fileFormatTab: 'Format Pliku',
    fgColor: 'Kolor Pierwszego Planu',
    bgColor: 'Kolor Tła',
    enableGradient: 'Włącz Gradient',
    gradientType: 'Typ Gradientu',
    linear: 'Liniowy',
    radial: 'Radialny',
    selectFrame: 'Wybierz Ramkę',
    selectLogo: 'Wybierz Logo',
    uploadCustomLogo: 'lub prześlij własne logo',
    uploadImage: 'Prześlij Obraz',
    downloadFormat: 'Format Pobierania',
    preview: 'Podgląd',
    downloadFormatBtn: 'Pobierz {format}',
    pngDesc: 'Bezstratny, obsługa przezroczystości',
    jpgDesc: 'Popularny/uniwersalny format pliku',
    webpDesc: 'Nowoczesny format, najlepsza jakość/rozmiar',
    svgDesc: 'Skalowalna grafika wektorowa',
    pdfDesc: 'Dokument gotowy do druku',
    lat: 'Szerokość:',
    lng: 'Długość:',
    qrCode: 'Kod QR',
    scanMe: 'Zeskanuj Mnie',
    scanHere: 'Skanuj Tutaj',    blog: {
      card1: {
        title: '1. Czym jest kod QR?',
        intro1: 'Pełna forma kodu QR to "Quick Response code" (kod szybkiej odpowiedzi). Ponieważ informacje w nim przechowywane są dekodowane bardzo szybko, nazywa się go kodem Quick Response (QR).',
        intro2: 'Kod QR to dwuwymiarowy kod cyfrowy czytelny tylko dla maszyn. Dane w nim nie mogą być odczytane przez człowieka. Zawiera bloki do przechowywania informacji takich jak tekst, numery telefonów, linki i lokalizacje map Google itp.',
        inventionTitle: 'Jak wynaleziono kod QR:',
        inventionText: 'Kod QR został wynaleziony w 1994 roku. Masahiro Hara i jego zespół pracowali w japońskiej firmie o nazwie Denso Wave, która produkowała części samochodowe dla firmy Toyota. Chcieli kodu, który przechowuje znacznie więcej informacji niż zwykły kod kreskowy, i tak wynaleźli kod QR.',
        keyFeaturesTitle: 'Kluczowe cechy kodu QR',
        keyFeatures: [
          {
            title: 'Jak działa QR',
            text: 'Wpisujesz tekst lub link, aby wygenerować kod QR. Generator QR tworzy kwadratowe pola zgodnie z informacją. Każde pole reprezentuje jeden bit, a każdy bit przechowuje jeden znak.',
          },
          {
            title: 'Struktura kodu QR',
            text: 'Kod QR zawiera trzy duże pola kwadratowe do identyfikacji orientacji kodu QR oraz jedno małe pole kwadratowe do przechowywania bitów (informacji).',
          },
          {
            title: 'Pojemność danych kodu QR',
            text: 'Zazwyczaj kod QR przechowuje więcej informacji niż kod kreskowy. Kod QR to po prostu zaawansowana wersja kodu kreskowego. To zasadniczo dwuwymiarowy kod kreskowy. Kod QR przechowuje prawie 200 znaków. Może również przechowywać 400 znaków, ale może być trudny do skanowania. Przechowywanie więcej niż 400 znaków może spowodować bardzo złożony kod QR, który prawie nie da się skanować.',
          },
          {
            title: 'Wykrywanie błędów w kodach QR',
            text: 'Kod QR może być wciąż skanowany, jeśli część informacji jest zarysowana lub pewne bity są zmienione. Kod QR wykorzystuje technikę wykrywania błędów Reed-Solomona w celu wykrycia błędów i ich skorygowania po identyfikacji.',
          },
        ],
        errorTitle: 'Poziom korekcji błędów kodu QR:',
        errorIntro: 'Różne techniki wykrywania i korekcji błędów są używane w różnych przypadkach, jak opisano poniżej:',
        errorHeaders: {
          level: 'Poziom',
          recovery: 'Zdolność odzyskiwania',
          bestUse: 'Najlepsze zastosowanie',
        },
        errorRows: [
          {
            level: 'Niski (L)',
            recovery: '~7%',
            useCases: [
              'Ta technika korekcji błędów jest używana, gdy kod QR jest wyświetlany na ekranach cyfrowych, stronach internetowych lub w czystym środowisku.',
              'Gdy kod QR jest generowany dla małych informacji, takich jak Gmail, numer kontaktu lub mały tekst.',
            ],
          },
          {
            level: 'Średni (M)',
            recovery: '~15%',
            useCases: [
              'Do ulotek i plakatów zainstalowanych w czystym środowisku, gdy ryzyko uszkodzenia jest znikome.',
            ],
          },
          {
            level: 'Kwarcyl (Q)',
            recovery: '~25%',
            useCases: [
              'Gdy kod QR ma być zainstalowany w surowym środowisku, takim jak fabryka/na zewnątrz.',
              'Również, gdy małe logo jest potrzebne na środku, zasłania ono kilka bitów. Dlatego ta technika korekcji błędów jest potrzebna.',
            ],
          },
          {
            level: 'Wysoki (H)',
            recovery: '~30%',
            useCases: [
              'Używane, gdy możliwe jest duże uszkodzenie kodu QR.',
              'Gdy duże logo przykrywa środek kodu QR.',
              'Również, gdy potrzebne jest zaawansowane stylizowanie kodu QR.',
            ],
          },
        ],
      },
      card2: {
        title: '2. Dlaczego wybrać nasz generator kodów QR?',
        intro: 'Nasz generator kodów QR sprawia, że generowanie kodów QR jest niezwykle szybkie, bezpieczne i łatwe. Możesz dostosować swój kod, aby był bardziej zaawansowany, profesjonalny i pasował do tematu Twojej firmy. Wszystkie dostosowania, od kolorowania kodu QR do instalacji logo w kodzie QR, oferowane są bezpłatnie na zawsze.',
        strengths: [
          {
            title: 'Profesjonalne dostosowanie:',
            text: 'Możesz generować i dostosowywać tyle kodów QR, ile potrzebujesz bez żadnych kosztów. Wszystkie funkcje są całkowicie bezpłatne. Możesz stosować kolory gradientowe, różne kształty pól kwadratowych, logo niestandardowe i wiele innych funkcji.',
          },
          {
            title: 'Obsługa wielu formatów:',
            text: 'Nasz generator kodów QR oferuje wiele formatów pobierania dla Twojej wygody. Wystarczy wybrać preferowany format przed pobraniem. Obecnie oferujemy te formaty:',
          },
          {
            title: 'Gotowe szablony:',
            text: 'Możesz używać gotowych kolorów gradientowych i ramek, które uczyniają Twój kod QR profesjonalnym.',
          },
          {
            title: 'Obsługa logo niestandardowego:',
            text: 'Możesz również przesłać logo marki niestandardowe, które automatycznie pasuje do środka kodu QR. Możesz również wybrać logo z wbudowanej biblioteki logo, w której dostępnych jest ponad 30 logo.',
          },
          {
            title: 'Podgląd na żywo:',
            text: 'Podczas dostosowywania możesz obserwować wszystkie zmiany w panelu podglądu na żywo. Te zmiany w panelu podglądu są w czasie rzeczywistym i zmieniają się dynamicznie.',
          },
          {
            title: 'Wskaźnik skanowania:',
            text: 'Podczas wybierania kolorów odpowiednie ostrzeżenia i wskaźniki Cię poprowadzą, jeśli wybierzesz kolory trudne do zeskanowania.',
          },
        ],
        formatHeaders: {
          srNo: 'Lp.',
          formats: 'Formaty',
          description: 'Opis',
        },
        formatRows: [
          { no: '1', format: 'PNG', description: 'Bezstratny, obsługa przezroczystości' },
          { no: '2', format: 'JPG', description: 'Popularny, uniwersalny format pliku' },
          { no: '3', format: 'WEBP', description: 'Nowoczesny, najlepsza jakość/rozmiar' },
          { no: '4', format: 'SVG', description: 'Skalowalna grafika wektorowa' },
          { no: '5', format: 'PDF', description: 'Dokument gotowy do druku' },
        ],
      },
      card3: {
        title: '3. Przewodnik krok po kroku:',
        step1Intro: 'Przede wszystkim wybierz kategorię kodu QR, który chcesz wygenerować. Jeśli generujesz kod QR dla kontaktu, mapy, linku lub tekstu. Obecnie nasz generator kodów QR oferuje te kategorie:',
        categories: ['Link / URL', 'Tekst', 'WiFi', 'Kontakt', 'Gmail', 'Mapy Google'],
        step2: 'Po wybraniu kategorii wklej swoje informacje w polu tekstowym.',
        step3Intro: 'Następnie kliknij na Generuj i dostosuj, aby otworzyć panel dostosowywania. W panelu dostosowywania zobaczysz pasek podnawigu z następującymi opcjami:',
        options: [
          {
            title: 'Styl i kształt:',
            text: 'W tej sekcji możesz zmienić kształty pól kwadratowych na wiele stylów, takich jak zaokrąglone narożniki, punkty, paski poziome, paski pionowe, małe kwadraty i wiele innych.',
          },
          {
            title: 'Kolor:',
            text: 'W tej sekcji możesz wybrać niestandardowe kolory tła i pierwszego planu. Aby utworzyć kod QR w kolorach gradientu, masz opcję włączenia gradientu, który pozwala Ci zastosować dowolny kolor gradientu z wbudowanej biblioteki lub łatwo utworzyć kolor gradientu. Możesz również zmienić kąt kolorów gradientu liniowego. Obsługiwany jest również gradient promieniowy. Możesz dodać wiele kolorów, aby utworzyć profesjonalny efekt gradientu.',
          },
          {
            title: 'Ramki:',
            text: 'Tutaj możesz wybrać idealną ramkę do swojego kodu QR. Wszystkie ramki automatycznie pasują do Twojego kodu. Wystarczy wybrać ramkę z wbudowanej biblioteki.',
          },
          {
            title: 'Logo:',
            text: 'Po wyborze ramki możesz wybrać logo, które zostanie automatycznie dostosowane do środka kodu QR. Obsługiwane jest również przesłanie niestandardowego logo marki.',
          },
          {
            title: 'Szablony:',
            text: 'Jeśli nie chcesz wybierać stylu, kształtu, koloru i ramki osobno, możesz zastosować wstępnie wykonane szablony do kodu QR. Wiele szablonów premium jest dostępnych dla Twojej wygody, które są bezpłatne na zawsze.',
          },
          {
            title: 'Format pliku:',
            text: 'Na koniec musisz wybrać typ pliku, w którym chcesz pobrać kod QR. Obsługiwanych jest kilka popularnych formatów, w tym PNG, WEBP, SVG i PDF itp.',
          },
          {
            title: 'Edytuj dane QR:',
            text: 'Możesz również edytować dane QR bez żadnej utraty wybranych dostosowań.',
          },
        ],
        finalStep: 'Następnie wystarczy kliknąć przycisk pobierania, a kod QR dokładnie zgodnie z Twoimi dostosowaniami w wybranym formacie zostanie pobrany natychmiast bez żadnych kosztów.',
      },
      card4: {
        title: '4. Korzyści:',
        intro: 'Kod QR łączy świat fizyczny z doświadczeniem cyfrowym. To najszybszy sposób na udostępnianie linków, kontaktów lub Twojej lokalizacji. Wystarczy zeskanować kod QR, aby natychmiast uzyskać dostęp do informacji. Dlatego jest niezwykle popularne w biznesie i świecie cyfrowym, ponieważ jest oszczędne pod względem czasu i bardzo celowe.',
        benefits: [
          {
            title: 'Wsparcie na całe życie:',
            text: 'Kody QR funkcjonują na zawsze bez żadnej daty wygaśnięcia. Dają Ci przechowywane informacje natychmiast, gdy je zeskanujesz. Ponieważ zawiera zakodowane na stałe instrukcje cyfrowe, nigdy nie traci informacji.',
          },
          {
            title: 'Obsługa offline:',
            text: 'Możesz skanować kod QR nawet, gdy jesteś offline. Kamera Twojego telefonu komórkowego dekoduje wzory kodu QR i daje Ci przechowywane w nim informacje.',
          },
          {
            title: 'Koszt zerowy:',
            text: 'Ponieważ te kody nie wymagają żadnego przekierowania serwera ani zasobów, są bezpłatne na zawsze.',
          },
        ],
      },
    },  },

  qrScanner: {
    seo: {
      title: 'Skaner Kodów QR — Skanuj Kody QR z Kamery lub Obrazu | photremium.com',
      desc: 'Natychmiast skanuj kody QR kamerą lub przesyłając obraz. Wykrywa URL, tekst, WiFi, kontakty i więcej.',
      keywords: 'skaner kodów qr, skanuj kod qr, czytnik qr, kod qr online',
    },
    title: 'Skaner Kodów QR',
    desc: 'Natychmiast skanuj kody QR kamerą lub przesyłając obraz. Szybko i bezpiecznie.',
    generateQrCode: 'Generuj Kod QR',
    scan: 'Skanuj',
    cameraScanner: 'Skaner Kamerowy',
    uploadImage: 'Prześlij Obraz',
    pointCamera: 'Skieruj kamerę na kod QR',
    startCamera: 'Uruchom Kamerę',
    loading: 'Ładowanie…',
    dropQrImage: 'Upuść obraz kodu QR tutaj',
    toScan: 'do skanowania',
    supportedFormats: 'Obsługuje JPG, PNG, GIF, WEBP',
    ctrlVPaste: 'Wklej przez Ctrl+V',
    scanFromGallery: 'Skanuj z Galerii',
    instantScanning: 'Natychmiastowe skanowanie',
    instantScanningDesc: 'Wykrywanie kodów QR w czasie rzeczywistym z kamery lub przesłanych obrazów',
    private100: '100% prywatnie',
    private100Desc: 'Całe przetwarzanie odbywa się w Twojej przeglądarce. Nic nie jest przesyłane',
    multiFormat: 'Wiele formatów',
    multiFormatDesc: 'Wykrywa URL, tekst, WiFi, kontakty, e-mail, telefon i więcej',
    accessingCamera: 'Uzyskiwanie dostępu do kamery…',
    cameraDenied: 'Dostęp do kamery odrzucony. Zezwól na uprawnienia kamery i spróbuj ponownie.',
    noCamera: 'Nie znaleziono kamery w tym urządzeniu.',
    cameraError: 'Nie można uzyskać dostępu do kamery. Spróbuj ponownie.',
    videoError: 'Nie udało się uruchomić odtwarzania wideo.',
    switchError: 'Nie udało się przełączyć kamery.',
    tryAgain: 'Spróbuj Ponownie',
    switchCamera: 'Przełącz Kamerę',
    stop: 'Zatrzymaj',
    noQrFound: 'Nie Znaleziono Kodu QR',
    couldNotRead: 'Nie można odczytać obrazu',
    scannerFailed: 'Nie udało się załadować skanera',
    noQrFoundDesc: 'Nie wykryto kodu QR na obrazie. Spróbuj innego obrazu lub użyj skanera kamerowego.',
    qrScanned: 'Kod QR Zeskanowany!',
    openLink: 'Otwórz Link',
    copied: 'Skopiowano!',
    copy: 'Kopiuj',
    share: 'Udostępnij',
    scanAgain: 'Skanuj Ponownie',
    network: 'Sieć',
    password: 'Hasło',
    security: 'Zabezpieczenia',
    unknown: 'Nieznany',
    typeText: 'Tekst',
    typeUrl: 'URL',
    typeWifi: 'Sieć WiFi',
    typeContact: 'Wizytówka kontaktu',
    typeEmail: 'E-mail',
    typePhone: 'Numer telefonu',
    typeSms: 'SMS',
    typeLocation: 'Lokalizacja',
    blog: {
      tocTitle: 'Spis treści',
      sections: [
        {
          id: 'why-use-qr-code-scanner',
          title: '1. Dlaczego warto używać skanera kodów QR?',
          paragraphs: [
            'Skaner kodów QR to w zasadzie aparat mobilny, który dekoduje informacje zapisane w kodzie QR. Wystarczy skierować aparat na kod QR — niezależnie od orientacji kodu odczyta on konkretne wzorce, wykryje błędy, poprawi je w razie potrzeby i wyświetli zawarte informacje.',
          ],
          listTitle: 'Rodzaje skanerów kodów QR:',
          bullets: [
            'Skaner kodów QR oparty na WWW: Możesz skanować kod QR za pomocą skanerów online obsługiwanych przez Twoją przeglądarkę. Do informacji możesz uzyskać dostęp przez aparat lub skanowanie po przesłaniu obrazu. Aby skorzystać z automatycznego przekierowania i innych zaawansowanych funkcji, odwiedź https://photremium.com.',
            'Aparaty w telefonach: Niektóre nowoczesne telefony mają wbudowany skaner kodów QR w natywnej aplikacji aparatu. Potrafią pobrać i zdekodować informacje, po prostu skanując kod QR zwykłym aparatem.',
            'Aplikacje: Istnieją aplikacje stworzone specjalnie do skanowania kodów QR. Jednak w przypadku zaawansowanego przekierowania i wielu innych funkcji możesz zainstalować aplikację za darmo przez ten link: https://photremium.com.',
            'Urządzenia sprzętowe: Niektóre urządzenia sprzętowe również służą do skanowania kodów QR. Są one powszechnie używane w dużych centrach handlowych do rozliczania produktów.',
          ],
        },
        {
          id: 'why-choose-our-qr-code-scanner',
          title: '2. Dlaczego wybrać nasz skaner kodów QR?',
          paragraphs: [
            'Możesz odkryć wiele zaawansowanych funkcji — od przekierowania po kopiowanie treści zdekodowanej z kodu QR. W naszym skanerze kodów QR znajdziesz też wiele innych ciekawych funkcji, takich jak:',
          ],
          bullets: [
            'Duża szybkość: Nasz skaner kodów QR sprawia, że dekodowanie kodu QR jest wyjątkowo szybkie. Wystarczy zeskanować kod QR, a nasze narzędzie natychmiast poda informacje z zaawansowaną opcją kopiowania tekstu/linku, otwarcia po wykryciu linku lub automatycznego zapisu po wykryciu kontaktu.',
            'Bez instalacji: Nie musisz instalować osobnej aplikacji, aby korzystać z naszego skanera kodów QR. Narzędzie jest dostępne bezpłatnie w lokalnej przeglądarce.',
            'Dostęp międzyplatformowy: Możesz korzystać na dowolnym urządzeniu. Nie musisz się martwić wersją systemu ani innymi wymaganiami. Narzędzie działa na wszystkich wersjach i urządzeniach.',
            'Obsługa wszystkich formatów: Wszystkie formaty danych, które mogą być zapisane w kodzie QR, w tym zwykły tekst, WiFi, URL, kontakty, Gmail i Google Maps itp., są obsługiwane przez nasze narzędzie.',
          ],
        },
        {
          id: 'step-by-step-guide',
          title: '3. Przewodnik krok po kroku:',
          steps: [
            {
              heading: '1. Najpierw wybierz metodę skanowania kodu QR. Są na to dwie metody:',
              subSteps: [
                {
                  heading: 'i. Metoda aparatu',
                  paragraphs: [
                    'Możesz skanować kod QR kamerą urządzenia, nawet jeśli używasz laptopa, komputera PC lub dowolnego urządzenia obsługującego zwykłą kamerę. Kliknięcie przycisku “Start Camera” wywoła prośbę o uprawnienie — zezwól tej stronie na użycie aparatu do skanowania QR. Jeśli przypadkowo odmówiłeś lub prośba nie pojawia się, możesz nadać dostęp do aparatu ręcznie, wykonując te kroki:',
                  ],
                  notes: [
                    '➔ Dla Chrome (Android / Desktop):',
                    '1. Kliknij trzy kropki',
                    '2. Przejdź do Settings',
                    '3. (Pomiń ten krok na Androidzie) Privacy and Security',
                    '4. Kliknij Site Settings',
                    '5. Następnie w sekcji permissions kliknij Camera',
                    '6. Znajdź URL naszej strony: https://photremium.com/qr-code-scanner',
                    '7. Zezwól na kamerę z listy rozwijanej.',
                    '➔ Dla Safari (iPhone / iOS):',
                    '1. Stuknij ikonę AA lub Website Settings na pasku adresu.',
                    '2. Wybierz Website Settings.',
                    '3. Stuknij Camera i wybierz Allow.',
                    '4. Jeśli nadal jest blokowane: przejdź do iPhone Settings > Safari > Camera i ustaw Ask lub Allow.',
                  ],
                },
                {
                  heading: 'ii. Metoda galerii',
                  paragraphs: [
                    'Możesz przesłać obraz kodu QR, aby uzyskać dostęp do jego informacji. Kliknij przycisk “Scan from Gallery”, a otworzy się eksplorator plików. Następnie wybierz obraz kodu QR. Obsługiwane są wszystkie formaty obrazów, takie jak jpg, .jpeg, .png, .gif, .webp, .svg, .avif, .heic, .heif, .jxl, .bmp, .ico, .tiff, .tif, .jfif, .jpe, .pjpeg, .pjp, .apng, .svgz oraz .xbm itd.',
                  ],
                },
              ],
            },
            {
              heading: '2. Po wybraniu kodu QR wyświetlane są wszystkie informacje, co pozwala kopiować, udostępniać lub otworzyć link, jeśli zostanie wykryty. Możesz też zeskanować ponownie, jeśli chcesz.',
            },
          ],
        },
        {
          id: 'benefits-of-qr-code-scanner',
          title: 'Korzyści ze skanera kodów QR:.',
          paragraphs: [
            'Skaner kodów QR oferuje wiele korzyści w tym cyfrowym świecie. Ułatwia i przyspiesza płatności, weryfikacje oraz dostęp do informacji nawet w trybie offline.',
          ],
          bullets: [
            'Natychmiastowy dostęp do informacji: Zeskanowanie kodu QR dostarcza informacje w ułamku milisekundy. Narzędzie dekoduje wzorce, wykrywa błędy i bardzo szybko je usuwa, zapewniając użytkownikowi wyjątkowo szybkie działanie.',
            'Płynna komunikacja: W tej erze rozwoju istnieje pilna potrzeba szybkiej i bezpiecznej komunikacji dla drobnych informacji, takich jak dane bankowe i dane produktu itp. Skaner kodów QR rozwiązuje ten problem, ponieważ płatności realizuje się przez zeskanowanie kodu QR. Google również weryfikuje telefon przez QR podczas tworzenia nowego konta na laptopie.',
            'E-bilety: Na dworcach autobusowych, kolejowych czy lotniskach możesz łatwo zweryfikować bilet bez długiego czekania w kolejce. Co więcej, skanery kodów QR są instalowane w wielu miejscach na lotniskach, aby ograniczyć kolejki. To także zmniejsza zapotrzebowanie na pracowników, automatycznie oszczędzając budżet linii lotniczych.',
            'Uwierzytelnianie produktu: Zaawansowane i premium marki umieszczają kod QR na produkcie. Klient może zeskanować ten kod QR, aby sprawdzić autentyczność produktu i potwierdzić, czy jest oryginalny.',
          ],
        },
      ],
    },
  },

  faceBlur: {
    seo: {
      uploadTitle: 'Narzędzie do Rozmycia Twarzy — Rozmyj Twarze na Obrazach Online | photremium.com',
      uploadDesc: 'Automatycznie rozmywaj twarze na obrazach przy użyciu AI. Wybierz intensywność, kształt lub emoji.',
      uploadKeywords: 'rozmycie twarzy, rozmyj twarz, wykrywanie twarzy, narzędzie prywatności',
      workspaceTitle: 'Narzędzie do Rozmycia Twarzy — photremium.com',
      workspaceDesc: 'Automatycznie rozmywaj twarze na obrazach. 100% bezpłatne.',
      workspaceKeywords: 'rozmycie twarzy, wykrywanie twarzy',
    },
    title: 'Rozmycie Twarzy',
    desc: 'Automatycznie wykrywaj i rozmywaj twarze na obrazach, aby chronić prywatność.',
    toBlurFaces: 'do rozmycia twarzy',
    autoDetection: 'Automatyczne Wykrywanie',
    autoDetectionDesc: 'Wykrywanie twarzy AI natychmiast znajduje wszystkie twarze',
    customBlur: 'Niestandardowe Rozmycie',
    customBlurDesc: 'Reguluj intensywność, kształt i styl rozmycia',
    private100: '100% Prywatne',
    private100Desc: 'Całe przetwarzanie odbywa się lokalnie w przeglądarce',
    blurTools: 'Narzędzia Rozmycia',
    faces: 'Twarze',
    faceDetection: 'Wykrywanie Twarzy',
    detecting: 'Wykrywanie...',
    autoDetectFaces: 'Automatycznie Wykryj Twarze',
    exitManualMode: 'Wyjdź z Trybu Ręcznego',
    manualSelect: 'Ręczny Wybór',
    nFaceRegions: 'Znaleziono {n} obszarów twarzy',
    noFacesDetected: 'Nie wykryto twarzy — użyj trybu ręcznego',
    manualHint: 'Kliknij i przeciągnij, aby narysować prostokąt nad obszarem do rozmycia.',
    blurType: 'Typ Rozmycia',
    blur: 'Rozmycie',
    emoji: 'Emoji',
    blurIntensity: 'Intensywność Rozmycia',
    strength: 'Siła',
    blurShape: 'Kształt Rozmycia',
    rectangle: 'Prostokąt',
    ellipse: 'Elipsa',
    circle: 'Okrąg',
    chooseEmoji: 'Wybierz Emoji',
    blurRegionsN: 'Obszary Rozmycia ({n})',
    faceN: 'Twarz {n}',
    manualRegionN: 'Obszar Ręczny {n}',
    manualN: 'Ręczny {n}',
    clearAllRegions: 'Wyczyść Wszystkie Obszary',
    processingDots: 'Przetwarzanie...',
    downloadBlurred: 'Pobierz Rozmyty Obraz',
    downloadNImages: 'Pobierz {n} Obrazów',
    downloadDialogTitle: 'Nie Wszystkie Obrazy Są Edytowane',
    downloadDialogText: 'Edytowano {edited} z {total}.',
    downloadAll: 'Pobierz Wszystkie',
    removeRegion: 'Usuń Obszar',
    region: 'Obszar',
    notAllEdited: 'Nie Wszystkie Obrazy Są Edytowane',
    editedXofY: 'Edytowano {edited} z {total}.',
    nextImage: 'Następny Obraz',
  },

  faqData: {
    imageConverter: [
      { q: 'Jakie formaty obrazów są obsługiwane do konwersji?', a: 'Obsługujemy JPG, PNG, WEBP, SVG, GIF, BMP, ICO i TIFF. Możesz natychmiast konwertować między tymi formatami w przeglądarce.' },
      { q: 'Czy jakość obrazu jest zachowana podczas konwersji?', a: 'Dla formatów bezstratnych jak PNG jakość jest w pełni zachowana. Dla formatów stratnych jak JPG i WEBP używamy zoptymalizowanych ustawień kodowania.' },
      { q: 'Czy istnieją ograniczenia rozmiaru lub liczby plików?', a: 'Brak ścisłych ograniczeń. Możesz przesłać wiele obrazów na raz i konwertować je zbiorczo.' },
      { q: 'Czy moje dane są bezpieczne? Czy obrazy są przesyłane na serwer?', a: 'Absolutnie. Całe przetwarzanie odbywa się w Twojej przeglądarce. Twoje obrazy nigdy nie opuszczają urządzenia.' },
      { q: 'Czy mogę konwertować przezroczysty PNG do JPG?', a: 'Tak. Ponieważ JPG nie obsługuje przezroczystości, przezroczyste obszary są domyślnie wypełniane białym tłem.' },
    ],
    imageCompressor: [
      { q: 'Czy kompresja obrazu obniży jego jakość?', a: 'Nie, kompresja nie wpływa zauważalnie na jakość, dopóki nie przekroczysz zalecanych zakresów. O jakości informują wskaźniki: i. Kompresja 1% do 40%: zielony wskaźnik z komunikatem „Dobra jakość”. ii. Kompresja 41% do 60%: żółty wskaźnik z komunikatem „Normalna jakość”. Ten zakres jest zwykle najbardziej zalecany. iii. Kompresja 61% do 100%: system pokazuje czerwone ostrzeżenie „Słaba jakość”, a spadek jakości może być wyraźnie widoczny.' },
      { q: 'Jakie formaty obrazów są obsługiwane przy kompresji?', a: 'Nasz kompresor obrazów obsługuje wszystkie poniższe formaty:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Czy mogę kompresować wiele obrazów jednocześnie?', a: 'Tak, oczywiście. Możesz kompresować wiele obrazów naraz (nawet 100+), jeśli Twoje urządzenie na to pozwala. Ponieważ kompresja wykorzystuje zasoby urządzenia, wydajniejszy laptop, komputer lub telefon zapewni lepszą szybkość. Jeśli masz słabszy sprzęt, możesz kompresować partiami — narzędzie pozostaje darmowe także przy wielu partiach.' },
      { q: 'Czy przechowujecie lub przesyłacie nasze obrazy na swoje serwery?', a: 'Nie, nigdy nie przesyłamy ani nie przechowujemy Twoich obrazów na naszych serwerach. Wszystkie obrazy są kompresowane lokalnie w przeglądarce. Pliki nigdy nie opuszczają Twojego urządzenia, więc możesz bez stresu kompresować także prywatne zdjęcia.' },
      { q: 'Czy to narzędzie do kompresji obrazów jest darmowe?', a: 'Tak, nasz kompresor obrazów jest całkowicie darmowy na zawsze. Nigdy nie poprosimy o płatność. Nie ma ukrytych opłat. Wszystkie funkcje, w tym kompresja wielu obrazów, są bezpłatne.' },
    ],
    cropImage: [
      { q: 'Czy przycinanie obrazu obniża jego jakość?', a: 'Nie, przycinanie obrazu nie wpływa na jego jakość wizualną. Przycinanie usuwa tylko niechcianą część obrazu. Nigdy nie zmienia pikseli tej części, która zostaje po przycięciu. Dlatego możesz przycinać obrazy w oryginalnej jakości bez żadnych uszkodzeń pikseli.' },
      { q: 'Jakie formaty obrazów obsługuje narzędzie do przycinania?', a: 'Możesz wybrać obraz w dowolnym formacie, ponieważ nasze narzędzie do przycinania obsługuje prawie wszystkie formaty obrazów. Lista poniżej:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
      { q: 'Czy moje obrazy są przesyłane na wasz serwer?', a: 'Nie, całe przetwarzanie odbywa się w Twojej lokalnej przeglądarce. Twoje obrazy nigdy nie są przesyłane na nasz serwer, ponieważ nie opuszczają Twojego urządzenia. Dzięki temu możesz przycinać prywatne obrazy naszym narzędziem bez żadnego ryzyka.' },
      { q: 'Czy mogę przycinać wiele obrazów jednocześnie?', a: 'Tak, możesz przycinać wiele obrazów (nawet 100+) jednocześnie, jeśli Twój system to obsługuje. Ponieważ przycinanie używa zasobów systemu, na wydajnym laptopie, komputerze lub telefonie możesz przycinać wiele obrazów naraz. Jeśli masz słabsze urządzenie, możesz przycinać obrazy partiami, bo narzędzie jest darmowe nawet przy dużej liczbie obrazów.' },
      { q: 'Czy to narzędzie do przycinania obrazów jest darmowe?', a: 'Tak, to narzędzie do przycinania obrazów jest całkowicie darmowe na zawsze. Możesz korzystać z niego wszędzie, o każdej porze i na dowolnym urządzeniu. Otrzymasz responsywny interfejs dla wszystkich urządzeń i nigdy nie zobaczysz prośby o płatność za funkcje premium. Wszystkie funkcje są całkowicie darmowe, bez ukrytych opłat.' },
    ],
    resizeImage: [
      { q: 'Czy mogę zmieniać rozmiar wielu obrazów jednocześnie?', a: 'Oczywiście. Nasze narzędzie pozwala zmieniać rozmiar wielu obrazów naraz. Możesz przesłać tyle obrazów, ile obsługuje Twoje urządzenie, a silnik AI przetworzy je jednocześnie. Jeśli masz słabsze urządzenie, lepiej działać partiami, aby uniknąć opóźnień. Całość działa lokalnie bez wysyłania plików na serwer, więc prywatność jest zachowana.' },
      { q: 'Czy to narzędzie do zmiany rozmiaru obrazów jest darmowe?', a: 'Tak, narzędzie jest całkowicie darmowe na zawsze. Nie ma płatnej subskrypcji wymaganej do funkcji premium. Nie ma też ukrytych opłat przy pobieraniu obrazów po zmianie rozmiaru.' },
      { q: 'Czy zmiana rozmiaru obniża jakość obrazu?', a: '✅Decrease Size (downscale): Zmniejszanie obrazu nie obniża jakości wizualnej. Często obraz po zmniejszeniu może wyglądać nawet ostrzej niż oryginał. Dlatego zmniejszanie do mniejszego rozmiaru zazwyczaj nie powoduje utraty jakości.\n❌Increase Size (upscale): Powiększanie obrazu ponad oryginalny rozmiar może wpłynąć na jakość wizualną. Im większe powiększenie, tym większe ryzyko spadku jakości.' },
      { q: 'Czy to narzędzie jest bezpieczne?', a: 'Tak, nasze narzędzie jest bezpieczne, szczególnie dla zdjęć prywatnych i wrażliwych. Wszystkie obrazy są przetwarzane lokalnie na Twoim urządzeniu i żadne dane go nie opuszczają. Możesz więc zmieniać rozmiar bez ryzyka prywatności.' },
      { q: 'Jakie formaty obrazów są obsługiwane?', a: 'Nasz resizer obsługuje wszystkie formaty obrazów. Możesz wybrać obrazy w następujących formatach:\n.jpg .jpeg .png .gif .webp .svg .avif .heic .heif .jxl .bmp .ico .tiff .tif .jfif .jpe .pjpeg .pjp .apng .svgz .xbm' },
    ],
    removeBackground: [
      { q: 'Jak działa usuwanie tła?', a: 'Używamy zaawansowanych modeli AI działających bezpośrednio w przeglądarce, aby wykryć obiekt i oddzielić go od tła.' },
      { q: 'Czy działa dla złożonych teł?', a: 'Tak. Model AI radzi sobie z różnymi scenami. Najlepsze wyniki są osiągane przy wyraźnym kontraście między obiektem a tłem.' },
      { q: 'Czy mogę usunąć tło z wielu obrazów jednocześnie?', a: 'Tak. Prześlij wiele obrazów, a narzędzie przetworzy je sekwencyjnie.' },
      { q: 'Jaki jest format wyjściowy?', a: 'Wyjście to zawsze plik PNG z przezroczystym tłem.' },
      { q: 'Czy moje obrazy są wysyłane na serwer?', a: 'Nie. Model AI działa w pełni w przeglądarce przy użyciu WebAssembly.' },
    ],
    watermarkImage: [
      { q: '1. Czy narzędzie Photremium do znaków wodnych jest bezpłatne?', a: 'Tak — narzędzie na photremium.com/watermark-image jest darmowe i nie wymaga konta ani subskrypcji. Możesz stosować znaki wodne do pojedynczych obrazów lub całych partii bez ograniczeń.' },
      { q: '2. Ile obrazów można przetworzyć jednocześnie?', a: 'Narzędzie obsługuje operacje wsadowe. Możesz przeciągnąć cały folder lub wybrać wiele plików — ograniczenie praktyczne wynika z pamięci urządzenia.' },
      { q: '3. Jakie formaty obrazów są obsługiwane?', a: 'Obsługiwane są formaty czytane przez File API: JPEG, JPG, PNG, WEBP, GIF (statyczny), BMP i SVG. Format wyjściowy odpowiada formatowi wejściowemu.' },
      { q: '4. Czy znak wodny będzie wyglądał tak samo na obrazach o różnych rozdzielczościach?', a: 'Tak. Silnik proporcjonalnego pozycjonowania oblicza względne położenie i skalę, zachowując wygląd znaku wodnego w całej partii.' },
      { q: '5. Czy mogę użyć własnego logo zamiast tekstu?', a: 'Tak. Przycisk "Add Image" pozwala załadować PNG z przezroczystym tłem, które zachowa przezroczystość i posłuży jako warstwa znaku wodnego.' },
      { q: '6. Jak ustawić półprzezroczystość znaku wodnego?', a: 'Wybierz warstwę znaku wodnego na kanwie i ustaw suwak krycia. 30–50% daje zwykle subtelny, profesjonalny efekt.' },
      { q: '7. Czy można dodać kilka warstw znaków wodnych?', a: 'Tak — system warstw obsługuje dowolną liczbę warstw, każda może mieć własne ustawienia.' },
      { q: '8. Co robi funkcja tiling i kiedy jej używać?', a: 'Tiling powtarza znak wodny w siatce po całym obrazie; przydatne gdy chcesz zapobiec nieautoryzowanemu użyciu obrazu.' },
      { q: '9. Czy narzędzie działa na urządzeniach mobilnych?', a: 'Tak — interfejs jest responsywny: miniatury stają się przewijaną linią, panel ustawień wysuwa się z dołu, a kontrolki obsługują dotyk.' },
      { q: '10. Czy moje obrazy są prywatne i czy są wysyłane na serwer?', a: 'Obrazy nie opuszczają urządzenia. Cały proces odbywa się lokalnie w przeglądarce z użyciem Canvas API; nie wykonuje się żadnego uploadu danych obrazów.' },
    ],
    qrCodeGenerator: [
      { q: 'Czy ten kod QR wygasa?', a: 'Nie, te kody QR nie wygasają i gwarantują wsparcie na całe życie. Ponieważ przechowują zahardkodowane instrukcje w postaci bitów wewnątrz kwadratowych pól, informacje w nich przechowywane nie mogą być zmieniane ani usuwane. Możesz uzyskać dostęp do informacji w kodzie, po prostu skanując go dowolnym aparatem, nawet po latach.' },
      { q: 'Dlaczego mój kod QR się nie skanuje?', a: 'Twój kod QR może nie być skanowany z następujących powodów: i. Niski kontrast: Jeśli wybierzesz podobne kolory tła i pierwszego planu, wpływa to na widoczność kodu QR i powoduje niepowodzenie skanowania. Ale nasze narzędzie przeprowadzi Cię przez dostosowanie dotyczące niskiego kontrastu lub jakichkolwiek innych problemów związanych ze skanowaniem. ii. Duże dane: Jeśli wygenerujesz kod QR dla bardzo dużego tekstu lub danych, staje się on bardzo złożony i powoduje problemy podczas skanowania. Walidator długości tekstu przeprowadzi Cię na temat optymalnej długości tekstu podczas generowania kodu QR. iii. Rozmyte drukowanie: Upewnij się, że pobrałeś kod QR w wysokiej rozdzielczości, takiej jak PNG lub SVG, które są już obsługiwane przez nasze narzędzie.' },
      { q: 'Czy mogę dodać logo do kodu QR?', a: 'Oczywiście, możesz dodać niestandardowe logo lub wybrać jedno z wbudowanej biblioteki logo dla swojego kodu QR. Wybrane logo zostanie automatycznie dostosowane w środku kodu QR.' },
      { q: 'Jak mogę skanować kod QR?', a: 'Możesz skanować kod QR, korzystając z aparatu telefonu komórkowego. Ale aby uzyskać automatyczne przekierowanie do linku i wiele innych zaawansowanych funkcji, możesz odwiedzić nasz skaner kodów QR, korzystając z linku https://photremium.com/qr-code-scanner bezpłatnie.' },
      { q: 'Ile kodów QR mogę wygenerować za darmo?', a: 'NIEOGRANICZONY! możesz generować wiele kodów QR za darmo. Wszystkie funkcje, dostosowania i szablony są darmowe na zawsze dla wszystkich. Nie ma potrzeby subskrypcji, aby cieszyć się funkcjami premium.' },
      { q: 'Czy muszę się zalogować/zarejestrować, aby wygenerować kod QR?', a: 'Nie, po prostu wpisz swój tekst, wygeneruj kod QR i pobierz go po dostosowaniu. Nie ma potrzeby logowania ani rejestracji, ponieważ wszystkie funkcje są dostępne całkowicie za darmo.' },
    ],
    qrCodeScanner: [
      { q: 'Czy mogę skanować kod QR z zapisanych obrazów i zrzutów ekranu?', a: '**Tak**, możesz skanować kod QR z zapisanych obrazów lub zrzutów ekranu. Nasz skaner kodów QR https://photremium.com/qr-code-scanner pozwala skanować kod QR z galerii. Wystarczy wybrać obraz, a otrzymasz wszystkie informacje odczytane z tego kodu QR.' },
      { q: 'Czy muszę instalować aplikację do skanera kodów QR?', a: '**Nie**, nasz webowy skaner kodów QR pozwala skanować kod QR bez instalowania jakiejkolwiek aplikacji. Z naszego zaawansowanego skanera kodów QR możesz korzystać bezpłatnie na każdym urządzeniu.' },
      { q: 'Dlaczego skaner nie rozpoznaje kodu QR?', a: 'Twój kod QR nie jest skanowany z jednego z następujących powodów: i. Niewystarczające światło: Skanowanie kodu QR przy słabym oświetleniu może powodować problemy. Włącz latarkę i zwiększ jasność, jeśli skanujesz z ekranu. ii. Odległość: Skanowanie kodu QR z nieodpowiedniej odległości również powoduje problemy. Optymalna odległość do skanowania kodu QR to około 10 cali (25cm). iii. Brudne soczewki aparatu: Kod QR może też nie zostać zeskanowany z powodu zabrudzonych soczewek. Wyczyść soczewki przed skanowaniem. “Widzisz siatkę w skanerze? Po prostu dopasuj do niej kod QR, aby zeskanować go poprawnie.”' },
      { q: 'Czy to narzędzie skanuje odwrócony lub kolorowy kod QR?', a: '**Tak**, możesz skanować QR w dowolnym kolorze i orientacji. Jednak jeśli kontrast między tłem a pierwszym planem jest niski, skanowanie może być utrudnione.' },
      { q: 'Czy to narzędzie jest darmowe?', a: '**Tak**, to narzędzie jest całkowicie darmowe. Możesz skanować nieograniczoną liczbę kodów QR za darmo na zawsze.' },
    ],
    faceBlur: [
      { q: 'Jak działa wykrywanie twarzy?', a: 'Model wykrywania twarzy zasilany AI działa bezpośrednio w Twojej przeglądarce. Identyfikuje twarze na obrazach.' },
      { q: 'Czy mogę wybrać, które twarze rozmyć?', a: 'Tak. Po wykryciu każdy obszar twarzy jest podświetlony i możesz wybrać twarze do rozmycia.' },
      { q: 'Jakie style rozmycia są dostępne?', a: 'Możesz wybrać rozmycie Gaussa, pikselizację lub nakładkę jednolitego koloru i regulować intensywność.' },
      { q: 'Czy mogę rozmyć twarze na wielu obrazach jednocześnie?', a: 'Tak. Prześlij wiele obrazów, skonfiguruj obszary rozmycia, a następnie pobierz wszystkie przetworzone obrazy.' },
      { q: 'Czy moje zdjęcia są wysyłane na zdalne serwery?', a: 'Nie. Model AI działa w Twojej przeglądarce przy użyciu WebAssembly.' },
    ],
    photoEditor: [
      { q: 'Jakie funkcje edycji są dostępne?', a: 'Regulacja jasności, kontrastu, nasycenia, stosowanie filtrów, dodawanie tekstu, nakładek, ramek i naklejek — wszystko w przeglądarce.' },
      { q: 'Czy mogę cofać i ponawiać zmiany?', a: 'Tak. Edytor obsługuje pełną historię cofania/ponawiania.' },
      { q: 'Jakie formaty plików można edytować i eksportować?', a: 'Możesz edytować JPG, PNG, WEBP i inne popularne formaty.' },
      { q: 'Czy edytor działa na telefonach?', a: 'Tak. Edytor jest w pełni responsywny i przyjazny dla ekranów dotykowych.' },
      { q: 'Czy moje obrazy są przechowywane na serwerze?', a: 'Nie. Cała edycja odbywa się lokalnie.' },
    ],
  },
};

export default pl;
